import React from 'react'
import { withTranslation } from 'react-i18next'
import { SignatureRequestProfileView, SignatureRequestProfileDocumentView, SignatureRequestProfileSignersView, SignatureRequestProfileResumeView, SignatureRequestCategoriesView } from '../../views'
import { LocalStorageService, DomainService, UserService, ContractService, ServiceService, SignatureTypesService, SignerTypeService, SignatureRequestService, ProcessTypeService, SignatureProfileService, ConvertDocumentService, ClientService, CompanyService, CategoryService, QuestionnaireService, CacheStorageService, AssembliesService, DocumentValidationService } from '../../../services/index'
import { InformationReliable, PersonalData, Documents, PDFView } from '../../../assets/logos/icons'
import { ValidateInputPure, SimpleLoading, VerifyContract, PromotionalFooterPure } from '../../pures'
import { formatPhoneNumberIntl, isValidPhoneNumber } from 'react-phone-number-input'
import { SignatureRequestValidator } from '../../../validators/index'
import initialState from '../../../utils/initialState'
import hash from 'object-hash'
import { Container, Grid } from '@material-ui/core'
import { withRouter } from 'react-router'
import { NIL as NIL_UUID } from 'uuid'
import { decryptMessageBoveda, PDFUtil, FormatTextUtil } from '../../../utils'
import { PDFDocument } from 'pdf-lib'

const gridInformationContactPlanStyles = {
  alignItems: 'start',
  justifyContent: 'space-between'
}
const containerInformationContactPlanStyles = {
  marginTop: '20px',
  marginBottom: '20px',
}
const globalContainerStyles = {
  backgroundColor: 'white',
  marginLeft: '20px',
  maxWidth: '100%',
}

class DragCell extends React.Component {
  render() {
    return (
      <td
        onDragOver={(e) => {
          DragCell.reorder(this.props.dataItem)
          e.preventDefault()
          e.dataTransfer.dropEffect = 'copy'
        }}
      >
        <span
          className='k-icon k-i-reorder'
          draggable='true'
          style={{ cursor: 'move' }}
          onDragStart={(e) => {
            DragCell.dragStart(this.props.dataItem)
            e.dataTransfer.setData('dragging', '')
          }}
        />
      </td>
    )
  }
}

class SignatureRequestProfileAction extends React.Component {

  /**Start action buttons back and next stepper**/
  onBackStep = () => {
    if (this.state.selectedStep === 0) {
      // If it comes from a contract, do not return to the requests module.
      if (this.state.isContractFromNegotiation) {
        this.props.history.goBack()
      } else {
        this.props.history.push('/signature-request-module')
      }
    } else {
      this.setState({
        selectedStep: this.state.selectedStep - 1
      })
      this.cancel()
    }
    return window.scroll(0, 0)
  }

  onNextStep = () => {
    this.setState({
      selectedStep: this.state.selectedStep + 1,
    })
    return window.scroll(0, 0)
  }

  /**End action buttons back and next stepper**/

  onFile = () => {
    this.setState({
      selectedStep: this.state.selectedStep + 1,
      selectedFile: this.state.selectedFile,
      documentConfirmAccept: this.state.documentConfirmAccept
    })
    return window.scroll(0, 0)
  }

  changeCategories = (data, changePage) => {
    let {
      companyIdSelected,
      categoryIdSelected,
      subCategoryIdSelected,
      pathBreadcrumbSelected,
      typeDocumentSelected,
      categoryNameSelected,
      subCategoryNameSelected
    } = data

    this.setState({
      isFirstTimeCategories: false,
      companyIdSelected,
      categoryIdSelected,
      subCategoryIdSelected,
      pathBreadcrumbSelected,
      typeDocumentSelected,
      categoryNameSelected,
      subCategoryNameSelected
    })
    if (changePage === 1) {
      this.onBackStep()
    } else {
      this.onNextStep()

    }
  }

  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      deletedSignatures: false,
      title: 'Nueva solicitud de firma',
      imgSignature: null,
      user: {},
      selectedStep: 0,
      selectedFileBase64: '',
      eventId: '',
      comments: '',
      dataItem: {},
      services: [],
      servicesTypeValue: [],
      signatureTypesInputValue: [],
      errorSignatureTypeId: false,
      signerTypeName: '',

      signerTypes: [],
      signatureRequests: [],
      signerTypesSelected: '',
      signerTypeSelected: '',
      visible: false,
      date: new Date(),
      signatureRequest: [],

      idCounter: 0,
      signerInEdit: undefined,
      userIsEditing: false,

      dialogTitle: '',
      selectedFile: null,
      numPages: null,
      pageNumber: 1,
      zoom: 1.0,
      validators: [],
      pagesArray: [],
      documentAccept: false,
      documentConfirmAccept: false,

      errorFile: false,
      errorAcceptDocument: false,
      errorDocumentConfirmAccept: false,
      errorNotSigners: false,
      errorCurrentEmail: false,
      errorCurrentEmailRegister: false,
      errorSignerType: false,
      errorCurrentName: false,
      errorCurrentLastName: false,
      errorCurrentFirstLastName: false,
      errorcurrentSecondLastName: false,
      errorCurrentPhoneNumber: false,
      errorNameUnique: false,
      errorServiceTypeId: false,
      // errorSignatureTypeId: false,
      errorCurrentNameSignature: false,
      errorCurrentComments: false,
      errorCurrentDescription: false,
      errorCurrentLimitDate: false,
      // disableSignerButton: true,
      showNotification: false,
      message: null,

      errorMessageCurrentNameSignature: '',
      errorMessageCurrentDescription: '',
      errorMessageCurrentComments: '',
      errorMessageCurrentLimitDate: '',

      selectedFileName: this.props.t('signatureRequestAction2.notSelectFile'),
      // selectedFileBase64: '',
      colorBorderContainer: 'gray',

      showLoadingRequesting: false,
      showCompletedRequesting: false,
      showErrorRequesting: false,
      isWarnign: false,
      messageWarning: '',
      showBtnCancelWarning: true,
      showBtnSubmitWarning: false,
      labelWarningBtnCancel: this.props.t('button.close'),
      titleDialog: '',

      errorNotValidators: false,
      errorNotSigns: false,
      visibleDialogDeleteSigner: false,

      signerToDelete: '',
      loadingContractsSignatures: true,
      contractsSignatures: {},
      buttonType: 0,

      getUserEmailFilterLoading: true,
      getUserEmailFilter: [],
      getUserNameFilterLoading: true,
      getUserNameFilter: {},

      firstLastName: '',
      firstName: '',
      getEmail: '',
      autocomplete: false,
      emailOrigin: '',

      loadingAutoComplete: false,
      getCollaboratorFilter: [],
      getCollaboratorLoading: false,

      token: '',
      url: '',
      firmante: false,
      userInformationFirstName: '',
      userInformationFirstLastName: '',
      userInformationSecondLastName: '',
      userInformationEmail: '',
      userInformationId: '',

      processTypes: [],
      processTypesInputValue: [],
      errorProcessTypeId: false,

      userType: '',

      showErrorDomain: false,
      showErrorDomainInvited: false,
      restOfTheMessage: '',
      messageSecond: '',
      requireSignSupport: false,
      collaboratorListAllow: [],
      inviteListAllow: [],

      // validators: [],
      signers: [],
      userSelectedList: [],
      processTypeId: '',
      // textData: this.props.t('signatureRequestProfileAction.textData'),
      // textDocument: this.props.t('signatureRequestProfileAction.textDocument'),
      // textSignerType: this.props.t('signatureRequestProfileAction.textSignerType'),
      // textResume: this.props.t('signatureRequestProfileAction.textResume'),
      name: '',
      newPdf: '',
      nameSignature: '',
      description: '',
      activeItem: null,
      activeItemValidator: null,
      signatureProfileSelected: {},
      signRequestSigners: [],
      servicesCheck: false,
      conservationMessage: false,
      timeStamp: false,
      advanced: false,
      autograph: false,
      eSign: false,
      aprovation: false,
      aprovationSequential: false,
      random: false,
      sequential: false,
      servicesCheck: '',
      servicesCheckTwo: '',
      signatureTypeCheck: '',
      signatureTypeCheckTwo: '',
      signatureTypeCheckThree: '',
      serviceId: '',
      signatureTypeId: '',
      skip: 0,
      take: 6,
      dateOriginal: new Date(),
      servicesId: [],
      timezone: null,

      serviceSTWillShow: false,
      serviceSTChecked: false,
      serviceSTCanModify: true,

      serviceCMWillShow: false,
      serviceCMChecked: false,
      serviceCMCanModify: true,

      signatureTypeESignWillShow: false,
      signatureTypeESignChecked: false,
      signatureTypeESignCanModify: true,

      signatureTypeAdvancedWillShow: false,
      signatureTypeAdvancedChecked: false,
      signatureTypeAdvancedCanModify: true,

      signatureTypeAutographWillShow: false,
      signatureTypeAutographChecked: false,
      signatureTypeAutographCanModify: true,

      processTypeRandomWillShow: false,
      processTypeRandomChecked: false,
      processTypeRandomCanModify: true,

      processTypeSequentialWillShow: false,
      processTypeSequentialChecked: false,
      processTypeSequentialCanModify: true,

      processTypeAprovationlWillShow: false,
      processTypeAprovationChecked: false,
      processTypeAprovationCanModify: true,

      processTypeAprovationSequentialWillShow: false,
      processTypeAprovationSequentialChecked: false,
      processTypeAprovationSequentialCanModify: true,

      errorSigner: false,

      contractFromNegotiation: {},
      isContractFromNegotiation: false,
      showDialogList: false,
      arraySelectedGridList: [],
      arrayNotSelectedGridList: [],
      newListGridShow: false,
      exportPdf: false,
      profilesDocuments: [],
      signersNoPassword: false,
      companies: [{ companyName: props.t('signatureRequestProfile.digitalVault.withoutAssign'), id: NIL_UUID }],
      categories: [{ id: 0, name: props.t('signatureRequestProfile.digitalVault.withoutAssign') }],
      subCategories: [{ items: [], subcategory: {} }],
      typeDocuments: [],
      allTypeDocuments: [],
      isFirstTimeCategories: true,
      companyIdSelected: NIL_UUID,
      categoryIdSelected: 0,
      subCategoryIdSelected: 0,
      pathBreadcrumbSelected: '',
      typeDocumentSelected: 0,
      proofOfLifeChecked: false,
      proofLifeCheckboxId: '',
      proofOfLifeOnlyPhoto: false,
      allInvites: [],
      language: 1,
      signtureRequestProfile: 1,
      allUsersCollaborator: [],
      allUsersInvite: [],
      documentFromVault: {}
    }

    DragCell.reorder = this.reorder.bind(this)
    DragCell.dragStart = this.dragStart.bind(this)
    this.toggleDialog = this.toggleDialog.bind(this)
    this.onDeleteData = this.onCancelData.bind(this)
  }

  notification = {
    type: {
      style: 'error',
      icon: true,
    },
    style: {
      bottom: 85,
      right: 30,
      position: 'fixed',
    },
  }

  steps = [
    {
      icon: InformationReliable,
      title: this.props.t('signatureRequestProfileAction.nameStepDocument'),
      next: this.props.t('requestReliableSignature.nextLaber'),
      back: this.props.t('requestReliableSignature.backLaber'),
    },
    {
      icon: PersonalData,
      title: this.props.t('signatureRequestProfileAction.nameStepSignerType'),
      next: this.props.t('requestReliableSignature.nextLaber'),
      back: this.props.t('requestReliableSignature.backLaber'),
    },
    {
      icon: Documents,
      title: this.props.t('signatureRequestProfileAction.nameStepVault'),
      next: this.props.t('requestReliableSignature.nextLaber'),
      back: this.props.t('requestReliableSignature.backLaber'),
    },
    {
      icon: PDFView,
      title: this.props.t('signatureRequestProfileAction.nameStepResume'),
      next: this.props.t('requestReliableSignature.sendToSign'),
      back: this.props.t('requestReliableSignature.backLaber'),
    }
  ]
  // { number: 0, component: SignatureRequestProfileDataView, back: this.onBackStep, next: this.onNextStep },

  stepMetadata = [
    // { number: 0, component: SignatureRequestProfileDocumentView, back: this.onBackStep, next: this.onFile },
    { number: 0, component: SignatureRequestProfileDocumentView, back: this.onBackStep, next: this.onFile },
    { number: 1, component: SignatureRequestProfileSignersView, back: this.onBackStep, next: this.onSigners },
    { number: 2, component: SignatureRequestCategoriesView, back: this.changeCategories, next: this.changeCategories },
    { number: 3, component: SignatureRequestProfileResumeView, back: this.onBackStep, next: this.onSubmit },
  ]

  token = {}
  url = process.env.REACT_APP_MIFIRMA_API
  localStorageService = new LocalStorageService()
  signatureRequestService = new SignatureRequestService(this.url)
  signerTypeService = new SignerTypeService(this.url)
  signatureTypesService = new SignatureTypesService(this.url)
  serviceService = new ServiceService(this.url)
  domainService = new DomainService(this.url)
  signatureProfileService = new SignatureProfileService(this.url)
  UserService = new UserService(this.url)
  contractService = new ContractService(this.url)
  processTypeService = new ProcessTypeService(this.url)
  convertDocumentService = new ConvertDocumentService(this.url)
  documentValidationService = new DocumentValidationService(this.url)
  clientService = new ClientService(this.url)
  companyService = new CompanyService(this.url)
  categoryService = new CategoryService(this.url)
  questionnaireService = new QuestionnaireService(this.url)
  cache = new CacheStorageService()
  isExternalSignature = false
  validator = SignatureRequestValidator(this.props.t)
  timeout = null
  ENV = process.env

  async componentDidMount() {

    this.setState({ loading: true })

    try {
      //Get the selected profile information
      let profileInfo = this.props.location.state?.dataItem || this.props.location.params?.dataItem
      let contractInfo = this.props.location.state?.contractInfo || this.props.location.params?.contractInfo
      let documentData = this.props.location.state?.documentData || this.props.location.params?.documentData
      let documents = []
      this.token = this.localStorageService.getLocalStorageItem('token').idToken
      this.user = this.localStorageService.getLocalStorageItem('user')
      let preferredLanguage = this.localStorageService.getLocalStorageItem('preferredLanguage')

      let userInformation = this.user.userMetaData.userA3Cloud
      let userInformationMiFirma = this.user.userMetaData.userMifirma
      let domains = await this.domainService.getDomains(this.token)
      const today = new Date()
      let url = window.location.href
      let paramsUrl = url.split('/')
      let signtureRequestProfile = paramsUrl.pop()

      this.cache.deleteUrlFromCache('/users-collaborators-invites')

      //Get information from selected profile by id
      let signatureProfileInfo = await this.signatureProfileService.getSignatureProfilesById(this.token, signtureRequestProfile)

      if (!signatureProfileInfo || !signatureProfileInfo.data) {
        throw new Error('No se pudo obtener la información del perfil de firma')
      }

      if (signatureProfileInfo?.data?.documentProfile?.documentProfile?.length > 1) {
        this.steps[0].title = this.props.t('signatureRequestProfileAction.nameStepDocuments')
      }

      //Calculated date to limit date signature
      let limiteDateObtained = new Date()
      if (Number(signatureProfileInfo.data.numberDaysLimit) !== 0) {
        const dateCalculated = today.setDate(today.getDate() + Number(signatureProfileInfo.data.numberDaysLimit))
        limiteDateObtained = new Date(dateCalculated)
      }

      let pdfBase64 = ''
      let selectedFileFromNegotiation = contractInfo ? contractInfo : documentData ? documentData : null

      if ((this.props.location.state && this.props.location.state.assemblyId) || (this.props.location.params && this.props.location.params.assemblyId)) {
        let assemblyId = this.props.location.state?.assemblyId || this.props.location.params?.assemblyId
        let assemblyInfo = await AssembliesService.getDocumentsAssembly(assemblyId, this.token)
        if (assemblyInfo.data?.length > 0) {
          documents = await Promise.all(assemblyInfo.data.map(async (doc) => {
            let blob = await fetch(doc.documentUrl).then(r => r.blob())
            let fileBase64 = await PDFUtil.baseTo64Pdf(blob)
            let pdfBase64 = fileBase64.split(',')[1]
            return {
              documentName: doc.document,
              url: pdfBase64,
              upload: true
            }
          }))
          pdfBase64 = documents[0].url
          if (!contractInfo) selectedFileFromNegotiation = true
          this.isExternalSignature = true
        }
      }
      if (contractInfo) {
        try {
          let blob = await fetch(contractInfo.url).then(r => r.blob())

          let fileBase64 = await PDFUtil.baseTo64Pdf(blob)

          if (!fileBase64) {
            throw new Error('PDFUtil.baseTo64Pdf devolvió undefined')
          }

          pdfBase64 = fileBase64.includes(',') ? fileBase64.split(',')[1] : fileBase64

          // Create a File object from the blob with the contract name
          // Asegurarse de que el nombre tenga la extensión .pdf
          let fileName = contractInfo.name.toLowerCase().endsWith('.pdf')
            ? contractInfo.name
            : `${contractInfo.name}.pdf`
          let file = new File([blob], fileName, { type: 'application/pdf' })
          selectedFileFromNegotiation = file

          //GET Digital Vault information
          let questionnaireId = contractInfo.questionnaireId
          // TODO: Implementar getDigitalVaultData si es necesario
          // this.getDigitalVaultData(questionnaireId)
        } catch (error) {
          console.error('Error procesando contractInfo:', error)
          throw error
        }
      }

      if (documentData) {
        this.isExternalSignature = true
        documentData.url = decryptMessageBoveda(documentData.url)
        let blob = await fetch(documentData.url).then(r => r.blob())

        let fileBase64 = await this.pdfToBase64(blob)
        pdfBase64 = fileBase64.split(',')[1]
      }

      let nameSignatureToShow = documentData && documentData.name && documentData.name !== ''
        ? documentData.name.split('/').pop().split('?')[0]
        : (contractInfo ? contractInfo.name.trim() : signatureProfileInfo.data.defaultName.trim())

      // let selectedFileFromNegotiation = contractInfo ? contractInfo : documentData ? documentData : null
      // let nameSignatureToShow = contractInfo ? contractInfo.name.trim() : signatureProfileInfo.data.defaultName.trim()

      let contractFromNegotiation = contractInfo ? true : false
      let nameBtnFile = contractInfo && contractInfo.name
        ? contractInfo.name
        : (documentData && documentData.url
          ? documentData.url.split('/').pop().split('?')[0]
          : this.props.t('signatureRequestAction2.notSelectFile'))

      let documentFromVault = null
      if (documentData && documentData.url && documentData.url !== '') {
        let splitUrl = documentData.url.split('?')
        let urlNameSplit = splitUrl[0].split('/')
        let documentName = urlNameSplit && urlNameSplit[8] ? urlNameSplit[8] : selectedFileFromNegotiation.name
        selectedFileFromNegotiation.name = documentName
        documentFromVault = documentData
      }



      let companyIdSelected = (signatureProfileInfo && signatureProfileInfo.data && signatureProfileInfo.data.classifierCategory && signatureProfileInfo.data.classifierCategory.companyId) ? signatureProfileInfo.data.classifierCategory.companyId : NIL_UUID
      let categoryIdSelected = (signatureProfileInfo && signatureProfileInfo.data && signatureProfileInfo.data.classifierCategory && signatureProfileInfo.data.classifierCategory.categoryId) ? signatureProfileInfo.data.classifierCategory.categoryId : 0
      let subCategoryIdSelected = (signatureProfileInfo && signatureProfileInfo.data && signatureProfileInfo.data.classifierCategory && signatureProfileInfo.data.classifierCategory.subCategoryId) ? signatureProfileInfo.data.classifierCategory.subCategoryId : 0
      let pathBreadcrumbSelected = (signatureProfileInfo && signatureProfileInfo.data && signatureProfileInfo.data.classifierCategory && signatureProfileInfo.data.classifierCategory.pathBreadcrumb) ? signatureProfileInfo.data.classifierCategory.pathBreadcrumb : ''
      let typeDocumentSelected = (signatureProfileInfo && signatureProfileInfo.data && signatureProfileInfo.data.classifierCategory && signatureProfileInfo.data.classifierCategory.typeDocumentId) ? signatureProfileInfo.data.classifierCategory.typeDocumentId : 0
      let language = preferredLanguage || 1

      let defaultDescription = signatureProfileInfo?.data?.defaultDescription || signatureProfileInfo?.data?.description || ''
      let defaultComments = signatureProfileInfo?.data?.defaultComments || signatureProfileInfo?.data?.comments || ''

      this.setState({
        userInformationId: userInformation.id,
        userInformationFirstName: userInformation.firstName,
        userInformationFirstLastName: userInformation.firstLastName,
        userInformationSecondLastName: userInformation.secondLastName,
        userInformationEmail: userInformation.email,
        userType: userInformationMiFirma.userType.id,
        signatureProfileSelected: signatureProfileInfo.data,
        documentsAssembly: documents,
        emailDomains: domains,
        date: limiteDateObtained,
        nameSignature: nameSignatureToShow,
        description: defaultDescription.trim(),
        comments: defaultComments.trim(),
        contractFromNegotiation: contractInfo,
        selectedFileBase64: pdfBase64,
        selectedFile: selectedFileFromNegotiation,
        isContractFromNegotiation: contractFromNegotiation,
        selectedFileName: nameBtnFile,
        companyIdSelected,
        categoryIdSelected,
        subCategoryIdSelected,
        pathBreadcrumbSelected,
        typeDocumentSelected,
        language,
        signtureRequestProfile,
        documentFromVault,
        selectedStep: 0,
        documentAccept: contractFromNegotiation ? true : false
      })
      const {
        serviceTimeStamp,
        serviceConservationMessage,
        signatureTypeESign,
        signatureTypeAdvance,
        signatureTypeAutograph,
        processRandom,
        processSequential,
        processAprovation,
        processAprovationSequential,
        proofOfLife
      } = this.state.signatureProfileSelected

      //Biometric 
      if (proofOfLife) {
        let biometricId = 'proofOfLife'
        this.setState({
          proofOfLifeChecked: proofOfLife,
          proofLifeCheckboxId: biometricId
        })
      }

      /* === Validating services PSC Checkboxes === */
      /* 1.- Service ST (Stamp Time) || 2.- Service CM (Conservation Message) */
      if (serviceTimeStamp === true) {
        this.setState({
          serviceSTWillShow: true,
          serviceSTChecked: true,
          serviceSTCanModify: false,
          servicesId: this.state.servicesId.concat(1)
        })
      }

      if (serviceConservationMessage === true) {
        this.setState({
          serviceCMWillShow: true,
          serviceCMChecked: true,
          serviceCMCanModify: false,
          servicesId: this.state.servicesId.concat(2)
        })
      }

      if (serviceTimeStamp === false && serviceConservationMessage === false) {
        this.setState({
          serviceSTWillShow: true,
          serviceCMWillShow: true,
          serviceSTChecked: false,
          serviceCMChecked: false
        })
      }

      /* === Validating Signature Types Checkboxes === */
      /* 1.- ESign || 2.- Advanced || 3.- Autograph */
      let arraySignatureTypes = [
        { id: 1, active: signatureTypeESign },
        { id: 2, active: signatureTypeAdvance },
        { id: 3, active: signatureTypeAutograph }
      ]

      for (let i = 0; i < arraySignatureTypes.length; i++) {
        switch (arraySignatureTypes[i].id) {
          case 1:
            if (arraySignatureTypes[i].active === true) {
              this.setState({ signatureTypeESignWillShow: true })
            }
            if (signatureTypeESign === true && signatureTypeAdvance === false && signatureTypeAutograph === false) {
              this.setState({
                signatureTypeESignChecked: true,
                signatureTypeESignCanModify: false,
                signatureTypeId: 1,
              })
            }
            break
          case 2:
            if (arraySignatureTypes[i].active === true) {
              this.setState({ signatureTypeAdvancedWillShow: true })
            }
            if (signatureTypeESign === false && signatureTypeAdvance === true && signatureTypeAutograph === false) {
              this.setState({
                signatureTypeAdvancedChecked: true,
                signatureTypeAdvancedCanModify: false,
                signatureTypeId: 2,
              })
            }
            break
          case 3:
            if (arraySignatureTypes[i].active === true) {
              this.setState({ signatureTypeAutographWillShow: true })
            }
            if (signatureTypeESign === false && signatureTypeAdvance === false && signatureTypeAutograph === true) {
              this.setState({
                signatureTypeAutographChecked: true,
                signatureTypeAutographCanModify: false,
                signatureTypeId: 3,
              })
            }
            break
          default:
            return false
        }
      }

      // If all signatureTypes have false value, then enable all checkboxes
      if (signatureTypeESign === false && signatureTypeAdvance === false && signatureTypeAutograph === false) {
        this.setState({
          signatureTypeESignWillShow: true,
          signatureTypeAdvancedWillShow: true,
          signatureTypeAutographWillShow: true
        })
      }

      /* === Validating Process Type Checkboxes === */
      /* 1.- Random || 2.- Sequential || 3.- Aprovation || 4.- AprovationSequential */
      let arrayProcessTypes = [
        { id: 1, active: processRandom },
        { id: 2, active: processSequential },
        { id: 3, active: processAprovation },
        { id: 4, active: processAprovationSequential }
      ]

      for (let i = 0; i < arrayProcessTypes.length; i++) {
        switch (arrayProcessTypes[i].id) {
          case 1:
            if (arrayProcessTypes[i].active === true) {
              this.setState({ processTypeRandomWillShow: true })
            }
            if (processRandom === true && processSequential === false && processAprovation === false && processAprovationSequential === false) {
              this.setState({
                processTypeRandomChecked: true,
                processTypeRandomCanModify: false,
                processTypeId: 1
              })
            }
            break
          case 2:
            if (arrayProcessTypes[i].active === true) {
              this.setState({ processTypeSequentialWillShow: true })
            }
            if (processRandom === false && processSequential === true && processAprovation === false && processAprovationSequential === false) {
              this.setState({
                processTypeSequentialChecked: true,
                processTypeSequentialCanModify: false,
                processTypeId: 2
              })
            }
            break
          case 3:
            if (arrayProcessTypes[i].active === true) {
              this.setState({ processTypeAprovationlWillShow: true })
            }
            if (processRandom === false && processSequential === false && processAprovation === true && processAprovationSequential === false) {
              this.setState({
                processTypeAprovationChecked: true,
                processTypeAprovationCanModify: false,
                processTypeId: 3
              })
            }
            break
          case 4:
            if (arrayProcessTypes[i].active === true) {
              this.setState({ processTypeAprovationSequentialWillShow: true })
            }
            if (processRandom === false && processSequential === false && processAprovation === false && processAprovationSequential === true) {
              this.setState({
                processTypeAprovationSequentialChecked: true,
                processTypeAprovationSequentialCanModify: false,
                processTypeId: 4,
              })
            }
            break
          default:
            return false
        }
      }

      // If all processTypes have false value, then enable all checkboxes
      if (processRandom === false && processSequential === false && processAprovation === false && processAprovationSequential === false) {
        this.setState({
          processTypeRandomWillShow: true,
          processTypeSequentialWillShow: true,
          processTypeAprovationlWillShow: true,
          processTypeAprovationSequentialWillShow: true,
        })
      }

    } catch (error) {
      this.props.history.push('/signature-request-module')
      // this.props.setShowError(true)
      return
    }
    //Get signer Type to signer Grid
    let signerTypes = initialState['signerTypeService.getSignerTypes']
    if (!signerTypes) {
      signerTypes = await this.signerTypeService.getSignerTypes(this.token)
      initialState['signerTypeService.getSignerTypes'] = signerTypes
    }

    //Get signature Types to checkbox
    let signatureTypes = initialState['signatureTypesService.getSignatureTypes']
    if (!signatureTypes) {
      signatureTypes = await this.signatureTypesService.getSignatureTypes(this.token)
      initialState['signatureTypesService.getSignatureTypes'] = signatureTypes
    }

    let processTypes = initialState['processTypeService.getProcessTypes']
    if (!processTypes) {
      processTypes = await this.processTypeService.getProcessTypes(this.token)
      initialState['processTypeService.getProcessTypes'] = processTypes
    }

    // let requests = await this.signatureRequestService.getSignatureRequests(
    //   0,
    //   1000,
    //   this.token
    // ) // Obtener todas las solicitudes enviadas para no repetir nombres

    // Obtener timezone
    let navegatorTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    let timezone = `${navegatorTimezone}`

    //GET preferences
    this.getPreferences()

    try {
      this.setState({
        signerTypes,
        processTypes,
        signatureTypes,
        timezone,
        // signatureRequests: requests.data,
        loadingContractsSignatures: true,
        token: this.token,
        url: this.url,
      })

    } catch (error) {
      this.props.history.push('/signature-request-module')
      this.props.setShowError(true)
      return
    }

    this.email = this.localStorageService.getLocalStorageItem(
      'user'
    ).userMetaData.userMifirma.email
    this.token = this.localStorageService.getLocalStorageItem('token').idToken
    let contractValidation = await this.contractService.getContractsSignatures(
      this.email,
      this.token
    )
    try {
      this.setState({
        loadingContractsSignatures: false,
        contractsSignatures: contractValidation,
      })
    } catch (error) {
      this.props.history.push('/signature-request-module')
      this.props.setShowError(true)
      return
    }

    try {
      let services = initialState['servicesService.getSignatureTypes']
      if (!services) {
        services = await this.serviceService.getServices(this.token)
        // Delete the service ID 3 to the list of services (BORRAR DESPUES)
        for (let i = 0; i < services.length; i++) {
          if (services[i].id === 3) services.splice(i, 1)
        }
        initialState['servicesService.getSignatureTypes'] = services
      }
      if (this.state.signatureProfileSelected.serviceConservationMessage || this.state.signatureProfileSelected.serviceTimeStamp === true) {
        this.setState({
          services:
            services.map((i) => (
              { ...i, isActive: true }
            )),
          loading: false
        })
      } else {
        this.setState({
          services:
            services.map((i) => (
              { ...i, isActive: false }
            )),
          loading: false
        })
      }
    } catch (error) {
      this.props.history.push('/signature-request-module')
      // this.props.setShowError(true)
      this.scrollWindow()
      return
    }

  }

  saveNewPdf = async (result) => {
    this.setState({ newPdf: result })
  }

  onChangeProofOfLifeOption = () => this.setState({ proofOfLifeOnlyPhoto: !this.state.proofOfLifeOnlyPhoto })


  onSigners = () => {
    const { signers, validators, signatureTypeId, processTypeId } = this.state // errorNotSigners, errorNotValidators, errorSignatureTypeId, errorProcessTypeId } = this.state
    let [emptySigners, emptyValidators, emptySignatureTypeId, emptyProcessTypeId] = [false, false, false, false]
    //Validation to selection signerType
    let emptySignature = false
    if (!signatureTypeId || signatureTypeId === null || signatureTypeId <= 0) {
      emptySignatureTypeId = true
      this.setState({ errorSignatureTypeId: true })
    } else { this.setState({ errorSignatureTypeId: false }) }
    //Validation to selection processType
    if (!processTypeId || processTypeId === null || processTypeId <= 0) {
      emptyProcessTypeId = true
      this.setState({ errorProcessTypeId: true })
    } else { this.setState({ errorProcessTypeId: false }) }

    // If the signature type or signing flow is missing, show the required fields modal
    if (emptySignatureTypeId === true || emptyProcessTypeId === true) {
      this.toggleWarningRequesting(4000, this.props.t('signaturePackageRequestProfileView.modal.description.warning'), this.props.t('signaturePackageRequestProfileView.modal.title.required'))
      return false
    }

    //Validation to selection signers
    if (!signers || signers === null || signers.length <= 0) {
      emptySigners = true

      this.toggleWarningRequesting(4000, this.props.t('signatureRequestAction2.notSigners'), this.props.t('signatureRequestProfileAction.dialog.title.no.signers'))
    }
    else { this.setState({ errorNotSigners: false }) }

    signers.map((signer) => {
      //Validate if signatureProfile selected has profile documents
      let profileWithProfileDocs = (this.state.signatureProfileSelected && this.state.signatureProfileSelected.documentProfile && this.state.signatureProfileSelected.documentProfile.documentProfile && this.state.signatureProfileSelected.documentProfile.documentProfile.length > 0) ? this.state.signatureProfileSelected.documentProfile.documentProfile : null
      if ((!signer.numSign || signer.numSign === 0) && signatureTypeId === 3 && !profileWithProfileDocs) {
        emptySignature = true
        this.setState({
          message: 'Falta agregar firma (s).'
        })
        this.toggleWarningRequesting(4000, this.props.t('signatureRequestProfileAction.error.signatures.missing'), this.props.t('signatureRequestProfileAction.dialog.title.no.signs'))
      }
    })

    if (!emptySignature) {
      this.setState({ errorNotSigns: false })
    }

    if (processTypeId === 3 || processTypeId === 4) {
      //Validation to selection validators
      if (!validators || validators === null || validators.length <= 0) {
        emptyValidators = true
        this.setState({
          message: this.props.t('signatureRequestAction2.notAuthorizers')
        })
        this.toggleErrorRequesting(true)
      }
      else { this.setState({ errorNotValidators: false }) }
    }

    if (emptySigners === true || emptyValidators === true || emptySignatureTypeId === true || emptyProcessTypeId === true || emptySignature === true) return false

    if (this.state.signatureProfileSelected && this.state.signatureProfileSelected.documentProfile && this.state.signatureProfileSelected.documentProfile.documentProfile && this.state.signatureProfileSelected.documentProfile.documentProfile.length > 0) {

      // let numberSigners = this.state.signatureProfileSelected.documentProfile.documentProfile[0].signersNum
      let numSignersToValidate = Math.max(...this.state.signatureProfileSelected.documentProfile.documentProfile.map(item => item.signersNum))
      if (Number(numSignersToValidate) !== signers.length) {
        this.setState({
          message: this.props.t('signatureRequest.profile.left-signers', { needed: numSignersToValidate, quantity: signers.length })
        })
        return this.toggleWarningRequesting(4000, this.props.t('signatureRequest.profile.left-signers', { needed: numSignersToValidate, quantity: signers.length }))
      }
    }

    this.setState({
      errorSignatureTypeId: false,
      errorProcessTypeId: false,
      errorNotSigners: false,
      errorNotValidators: false,
    })
    this.onNextStep()
  }

  // Change checkbox of service Stamp Time
  onSelectServiceST = () => {
    if (this.state.serviceSTCanModify === false) return false

    const serviceAlreadyExist = this.state.servicesId.find((item) => Number(item) === 1)
    if (!serviceAlreadyExist) {
      this.setState({
        serviceSTChecked: true,
        serviceCMChecked: false,
        servicesId: [1]
      })
    } else {
      let array = [...this.state.servicesId]
      let index = array.indexOf(1)

      if (index !== -1) {
        array.splice(index, 1)
        this.setState({
          serviceSTChecked: false,
          servicesId: array
        })
      }
    }
  }

  // Change checkbox of service Conservation Message
  onSelectServiceCM = () => {
    if (this.state.serviceCMCanModify === false) return false

    const serviceAlreadyExist = this.state.servicesId.find((item) => Number(item) === 2)
    if (!serviceAlreadyExist) {
      this.setState({
        serviceCMChecked: true,
        serviceSTChecked: false,
        servicesId: [2]
      })
    } else {
      let array = [...this.state.servicesId]
      let index = array.indexOf(2)

      if (index !== -1) {
        array.splice(index, 2)
        this.setState({
          serviceCMChecked: false,
          servicesId: array
        })
      }
    }
  }

  // Change Checkbox of signatureType ESign
  onSelectESign = () => {
    if (this.state.signatureTypeESignCanModify === false) return false

    let signers = this.state.signers
    signers.map((signer) => {
      signer.proofOfLife = false
      return signer
    })

    this.setState({
      signatureTypeESignChecked: true,
      signatureTypeAdvancedChecked: false,
      signatureTypeAutographChecked: false,
      signatureTypeId: 1,
      signatureTypeCheckThree: 'e.Firma',
      proofOfLifeChecked: false,
      proofLifeCheckboxId: '',
      signers
    })
  }

  // Change Checkbox of signatureType Advanced
  onSelectAdvanced = () => {
    if (this.state.signatureTypeAdvancedCanModify === false) return false

    let signers = this.state.signers
    signers.map((signer) => {
      signer.proofOfLife = false
      return signer
    })

    this.setState({
      signatureTypeESignChecked: false,
      signatureTypeAdvancedChecked: true,
      signatureTypeAutographChecked: false,
      signatureTypeId: 2,
      signatureTypeCheck: 'Firma Digital Avanzada',
      proofOfLifeChecked: false,
      proofLifeCheckboxId: '',
      errorSignatureTypeId: false,
      signers
    })
  }

  // Change Checkbox of signatureType Autograph
  onSelectAutograph = () => {
    if (this.state.signatureTypeAutographCanModify === false) return false

    let proofOfLifeChecked = false
    let proofLifeCheckboxId = ''

    if (this.state.signatureTypeAutographChecked) {
      proofOfLifeChecked = this.state.proofOfLifeChecked
      proofLifeCheckboxId = this.state.proofLifeCheckboxId
    }

    this.setState({
      signatureTypeESignChecked: false,
      signatureTypeAdvancedChecked: false,
      signatureTypeAutographChecked: true,
      signatureTypeId: 3,
      signatureTypeCheckTwo: 'Firma Autógrafa Digital',
      errorSignatureTypeId: false,
      proofOfLifeChecked,
      proofLifeCheckboxId,
    })
  }

  // Change Checkbox of process random
  onSelectRandom = () => {
    if (this.state.processTypeRandomCanModify === false) return false

    // Restore original noPassword state when changing flow
    const { signers } = this.state
    if (signers && signers.length > 0) {
      const updatedSigners = signers.map(signer => {
        if (signer._originalNoPassword !== undefined) {
          const restored = {
            ...signer,
            isSignerNoPassword: signer._originalNoPassword,
            noPasswordRequired: signer._originalNoPassword,
            proofOfLife: false,
            faceRecognition: false
          }
          return restored
        }
        return signer
      })

      this.setState({
        processTypeRandomChecked: true,
        processTypeSequentialChecked: false,
        processTypeAprovationChecked: false,
        processTypeAprovationSequentialChecked: false,
        processTypeId: 1,
        processTypeName: 'Aleatorio',
        proofOfLifeChecked: false,
        proofLifeCheckboxId: '',
        signers: updatedSigners
      })
    } else {
      this.setState({
        processTypeRandomChecked: true,
        processTypeSequentialChecked: false,
        processTypeAprovationChecked: false,
        processTypeAprovationSequentialChecked: false,
        processTypeId: 1,
        processTypeName: 'Aleatorio',
        proofOfLifeChecked: false,
        proofLifeCheckboxId: ''
      })
    }
  }

  // Change Checkbox of process sequential
  onSelectSequential = () => {
    if (this.state.processTypeSequentialCanModify === false) return false

    // Restore original noPassword state when changing flow
    const { signers } = this.state
    if (signers && signers.length > 0) {
      const updatedSigners = signers.map(signer => {
        if (signer._originalNoPassword !== undefined) {
          return {
            ...signer,
            isSignerNoPassword: signer._originalNoPassword,
            noPasswordRequired: signer._originalNoPassword,
            proofOfLife: false,
            faceRecognition: false
          }
        }
        return signer
      })

      this.setState({
        processTypeRandomChecked: false,
        processTypeSequentialChecked: true,
        processTypeAprovationChecked: false,
        processTypeAprovationSequentialChecked: false,
        processTypeId: 2,
        processTypeName: 'Sequencial',
        signers: updatedSigners
      })
    } else {
      this.setState({
        processTypeRandomChecked: false,
        processTypeSequentialChecked: true,
        processTypeAprovationChecked: false,
        processTypeAprovationSequentialChecked: false,
        processTypeId: 2,
        processTypeName: 'Sequencial'
      })
    }
  }

  // Change Checkbox of process aprovation
  onSelectAprovation = () => {
    if (this.state.processTypeAprovationCanModify === false) return false

    // Restore original noPassword state when changing flow
    const { signers } = this.state
    if (signers && signers.length > 0) {
      const updatedSigners = signers.map(signer => {
        if (signer._originalNoPassword !== undefined) {
          return {
            ...signer,
            isSignerNoPassword: signer._originalNoPassword,
            noPasswordRequired: signer._originalNoPassword,
            proofOfLife: false,
            faceRecognition: false
          }
        }
        return signer
      })

      this.setState({
        processTypeRandomChecked: false,
        processTypeSequentialChecked: false,
        processTypeAprovationChecked: true,
        processTypeAprovationSequentialChecked: false,
        processTypeId: 3,
        processTypeName: 'Aprobación',
        proofOfLifeChecked: false,
        proofLifeCheckboxId: '',
        signers: updatedSigners
      })
    } else {
      this.setState({
        processTypeRandomChecked: false,
        processTypeSequentialChecked: false,
        processTypeAprovationChecked: true,
        processTypeAprovationSequentialChecked: false,
        processTypeId: 3,
        processTypeName: 'Aprobación',
        proofOfLifeChecked: false,
        proofLifeCheckboxId: ''
      })
    }
  }

  // Change Checkbox of process aprovation sequential
  onSelectAprovationSequential = () => {
    if (this.state.processTypeAprovationSequentialCanModify === false) return false

    // Restore original noPassword state when changing flow
    const { signers } = this.state
    if (signers && signers.length > 0) {
      const updatedSigners = signers.map(signer => {
        if (signer._originalNoPassword !== undefined) {
          return {
            ...signer,
            isSignerNoPassword: signer._originalNoPassword,
            noPasswordRequired: signer._originalNoPassword,
            proofOfLife: false,
            faceRecognition: false
          }
        }
        return signer
      })

      this.setState({
        processTypeRandomChecked: false,
        processTypeSequentialChecked: false,
        processTypeAprovationChecked: false,
        processTypeAprovationSequentialChecked: true,
        processTypeId: 4,
        processTypeName: 'Aprobación secuencial',
        signers: updatedSigners
      })
    } else {
      this.setState({
        processTypeRandomChecked: false,
        processTypeSequentialChecked: false,
        processTypeAprovationChecked: false,
        processTypeAprovationSequentialChecked: true,
        processTypeId: 4,
        processTypeName: 'Aprobación secuencial'
      })
    }
  }

  // Change Date in DatePicker
  handleChangeLimitDate = (event) => {
    let today = new Date()
    let diff = (event.target.value.getTime() - today.getTime())
    let diferenceDays = Math.round(diff / (1000 * 60 * 60 * 24))

    if (diferenceDays > 60) {
      this.setState({
        errorCurrentLimitDate: true,
        errorMessageCurrentLimitDate: `${this.props.t('signatureRequestAction2.dateError')}`
      })
    } else {
      this.setState({
        date: event.target.value,
        errorCurrentLimitDate: false,
        errorMessageCurrentLimitDate: ''
      })
    }
  }

  reorder(dataItem) {
    const { key } = dataItem
    if (
      this.state[key === 'signers' ? 'activeItem' : 'activeItemValidator']
        .email === dataItem.email
    ) {
      return
    }
    let reorderedData = this.state[key].slice()
    let prevIndex = reorderedData.findIndex(
      (p) =>
        p.email ===
        this.state[key === 'signers' ? 'activeItem' : 'activeItemValidator']
          .email
    )
    let nextIndex = reorderedData.findIndex((p) => p.email === dataItem.email)
    reorderedData.splice(prevIndex, 1)
    reorderedData.splice(
      nextIndex,
      0,
      this.state[key === 'signers' ? 'activeItem' : 'activeItemValidator']
    )
    let params = {}
    params[key] = reorderedData
    if (key === 'signers') params.activeItem = this.state.activeItem
    else params.activeItemValidator = this.state.activeItemValidator
    this.setState(params)
  }

  dragStart(dataItem) {
    const { key } = dataItem
    let params = {}
    params[key] = this.state[key]
    if (key === 'signers') params.activeItem = dataItem
    else params.activeItemValidator = dataItem
    this.setState(params)
  }

  insertInToArray = (arr, index, newItem) => {
    return [...arr.slice(0, index), newItem, ...arr.slice(index)]
  }

  changeRows = (dataItem, sum, key) => {
    let currentSigner = {}
    let saveIndex = 0
    if (dataItem.id_order === 1 && sum == -1) {
      let sendToLast = this.state[key].filter((item, index) => index !== 0)
      sendToLast.push(this.state[key][0])
      this.setState({
        [key]: sendToLast,
      })

      return
    }

    if (dataItem.isLastItem && sum == 1) {
      let sendToFirst = this.state[key].filter(
        (item, index, arr) => arr.length - 1 !== index
      )
      sendToFirst = [this.state[key][this.state[key].length - 1]].concat(
        sendToFirst
      )
      this.setState({
        [key]: sendToFirst,
      })

      return
    }

    let tempSigners = this.state[key].filter((item, index) => {
      if (dataItem.email === item.email) {
        currentSigner = item
        saveIndex = index
      }
      return dataItem.email !== item.email
    })
    tempSigners = this.insertInToArray(
      tempSigners,
      saveIndex + sum,
      currentSigner
    )

    this.setState({
      [key]: tempSigners,
    })
  }

  setSignatureTypes = (val) => {
    // Restore original noPassword state for all signers when changing flow
    const { signers } = this.state

    if (signers && signers.length > 0) {
      const updatedSigners = signers.map(signer => {
        // If the signer has an original noPassword state saved, restore it
        if (signer._originalNoPassword !== undefined) {
          const restored = {
            ...signer,
            isSignerNoPassword: signer._originalNoPassword,
            noPasswordRequired: signer._originalNoPassword,
            proofOfLife: false,
            faceRecognition: false
          }
          return restored
        }
        return signer
      })

      this.setState({
        signatureTypesInputValue: val,
        errorSignatureTypeId: false,
        signers: updatedSigners
      })
    } else {
      this.setState({
        signatureTypesInputValue: val,
        errorSignatureTypeId: false
      })
    }
  }

  setProcessTypes = (val) =>
    this.setState({ processTypesInputValue: val, errorProcessTypeId: false })

  setServices = (services) => {
    this.setState({ services })
  }

  /**
  * @author Alan Aguilar
  * @description Method to close the alert of the form
  * @memberof SignatureRequestAction
  */
  onCloseOpenModal = () => {
    this.setState({ showNotification: false })
  }

  toggleShowDialogList = (value) => {
    this.setState({
      showDialogList: value,
    })
  }

  /**
 * @author Alan Aguilar
 * @description Method to show the notification and then close
 * @memberof SignatureRequestAction
 */
  handleMessage = (message) => {
    this.setState(
      {
        showNotification: true,
        message,
      },
      () => {
        setTimeout(() => {
          this.onCloseOpenModal()
        }, 8000)
      }
    )
  }

  /**
  * @author Alan Aguilar
  * @description Method to show the delete signer dialog modal
  * @memberof SignatureRequestAction
  */
  toggleDialogDeleteSigner = (dataItem) => {
    this.setState({
      visibleDialogDeleteSigner: !this.state.visibleDialogDeleteSigner,
    })
    if (this.state.visibleDialogDeleteSigner === false) {
      this.setState({ signerToDelete: dataItem })
    } else {
      this.setState({ signerToDelete: '' })
    }
  }

  /**
   * @author Alan Aguilar
   * @description Method to show the loading dialog modal
   * @memberof SignatureRequestAction
   */
  toggleLoadingRequesting = (value) => {
    this.setState({
      showLoadingRequesting: value,
    })
  }

  /**
 * @author Alan Aguilar
 * @description Method to show the confirmed sign dialog modal and redirecto to home
 * @memberof SignatureRequestAction
 */
  toggleCompletedRequesting = (value) => {
    this.setState(
      {
        showCompletedRequesting: value,
      },
      () => {
        setTimeout(() => {
          this.setState({ showCompletedRequesting: false })
          let myStorage = window.localStorage
          const tabSelected = {
            buttonFilterSelectedBlue: 'table-button-blue-active',
            buttonFilterSelectedGreen: '',
            buttonFilterSelectedRed: '',
            buttonFilterSelectedOrange: '',
            buttonFilterSelectedGray: '',
          }
          myStorage.setItem('tabSelected', JSON.stringify(tabSelected))
          this.props.history.push('/')
        }, 4000)
      }
    )
  }

  /**
   * @author Alan Aguilar
   * @description Method to show the error dialog modal
   * @memberof SignatureRequestAction
   */
  toggleErrorRequesting = (value) => {
    this.setState(
      {
        showErrorRequesting: value,
        // message: messageError
      },
      () => {
        setTimeout(() => {
          this.setState({ showErrorRequesting: false })
        }, 4000)
      }
    )
  }

  /**
   * @author Alan Aguilar
   * @description Method to show the error dialog modal
   * @memberof SignatureRequestAction
   */
  toggleWarningRequestingOld = () => {
    this.setState({ showWarningRequesting: !this.state.showWarningRequesting, showButton: !this.state.showButton })
  }

  /**
 * @author Lucia Alvarado
 * @description Method to show the error domain dialog modal
 * @memberof SignatureRequestProfileAction
 */
  toggleErrorDomain = (value) => {
    this.setState(
      {
        showErrorDomain: value,
      },
      () => {
        setTimeout(() => {
          this.setState({ showErrorDomain: false })
        }, 7000)
      }
    )
  }

  /**
   * @author Lucia Alvarado
   * @description Method to show the invited domain error in dialog modal
   * @memberof SignatureRequestProfileAction
   */
  toggleErrorDomainInvited = (value) => {
    this.setState(
      {
        showErrorDomainInvited: value,
      },
    )
  }
  /**
  * @author Lucia Alvarado
  * @description Method to show or hide dialog
  * @memberof SignatureRequestProfileAction
  */
  toggleDialog() {
    this.setState({
      visible: !this.state.visible,
    })
  }


  /**
 * @author Lucia Alvarado
 * @description Method to hide the dialog
 * @memberof SignatureRequestProfileAction
 */
  onCancelData() {
    this.setState({
      visible: !this.state.visible,
    })
  }

  /**
   * @author Lucia Alvarado
   * @description Insert new signer in the grid
   * @memberof SignatureRequestProfileAction
   */
  insert = () => {
    this.setState({
      signerInEdit: {},
      buttonType: 0,
    })
  }

  insertCollaborator = () => {
    this.setState({
      signerInEdit: {},
      buttonType: 2,
    })
  }

  insertValidator = () => {
    this.setState({
      signerInEdit: {},
      buttonType: 4,
    })
  }

  insertNoPassword = () => {
    this.setState({
      signerInEdit: {},
      buttonType: 5,
    })
  }

  /**
   * @author Lucia Alvarado
   * @description Add a signer
   * @param {Object} dataItem
   * @memberof SignatureRequestProfileAction
   */
  newSigner(dataItem) {
    const id = ++this.idCounter
    const newSigner = {
      id: id,
      email: '',
      signerType: '',
      sendDocument: true,
      languageId: dataItem.languageId
    }
    const result = Object.assign(newSigner, dataItem)
    // Save the original noPassword state after all assignments
    if (result._originalNoPassword === undefined) {
      const noPasswordValue = result.noPasswordRequired ?? result.isSignerNoPassword ?? false
      result._originalNoPassword = noPasswordValue
    }

    return result
  }

  selectSigner = (params) => this.setState({ signerInEdit: params }, () => this.save())


  /**
  * @author Lucia Alvarado
  * @description Save data of dialog List
  * @updated 01-09-2023
  * @memberof SignatureRequestProfileAction
  */
  validateSave = async (nameSigner, lastNameSigner, email, noPasswordRequired, isSignerNoPassword, firstName, firstLastName, secondLastName) => {
    this.setState({
      signerInEdit: {
        nameSigner,
        lastNameSigner,
        email,
        noPasswordRequired,
        isSignerNoPassword,
        firstName,
        firstLastName,
        secondLastName
      }
    })
    let signerExist = false
    if (this.state.buttonType !== 1) {//agregar}
      let currentSigners = this.state.signers
      currentSigners.forEach((signer) => {
        if (signer.email === email) {
          signerExist = true
        }
      })
      if (signerExist === true) {
        this.setState({
          errorCurrentEmailRegister: true,
          errorCurrentEmail: false,
        })
        return false
      } else {
        this.setState({
          errorCurrentEmailRegister: false,
        })
        let dataItem = this.state.signerInEdit
        // Preserve individual name fields with correct values
        dataItem.firstName = firstName || nameSigner || ''
        dataItem.firstLastName = firstLastName || ''
        dataItem.secondLastName = secondLastName || ''

        // Build display names for grid
        dataItem.nameSigner = dataItem.firstName
        dataItem.lastNameSigner = [dataItem.firstLastName, dataItem.secondLastName]
          .filter(Boolean)
          .map(v => String(v).trim())
          .filter(Boolean)
          .join(' ')
        dataItem.nameCompleted = `${dataItem.nameSigner} ${dataItem.lastNameSigner}`.trim()
        dataItem.email = `${email}`
        dataItem.sendDocument = true
        dataItem.noPasswordRequired = noPasswordRequired ?? false
        dataItem.isSignerNoPassword = isSignerNoPassword ?? noPasswordRequired ?? false
        const signers = this.state.signers
        // const signers = this.state.signers.slice()
        // const validators = this.state.validators.slice()
        const validators = this.state.validators
        const isNewSigner = dataItem.id === undefined
        if (this.state.buttonType === 2 || this.state.buttonType === 4) {
          let userEmailByDomain = dataItem.email ? dataItem.email : email
          let emailDomainSplit = userEmailByDomain.split('@')[1]
          let emailForbidden = true

          for (var i = 0; i < this.state.emailDomains.length; i++) {
            if (emailDomainSplit === this.state.emailDomains[i].name) {
              emailForbidden = false
              break
            }
          }
          if (emailForbidden) {
            this.setState({
              message: this.props.t('signatureRequest.pure.errorDomain'),
              messageSecond: this.props.t('signatureRequest.pure.errorDomainS'),
              restOfTheMessage: this.props.t('signatureRequest.pure.errorDomainAll')
            })
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(true)
            this.cancel()
            return false
          }
        }
        if (this.state.buttonType === 0 || this.state.buttonType === 5) {
          const hasNoPassword = dataItem.noPasswordRequired || dataItem.isSignerNoPassword || false
          dataItem.proofOfLife = (this.state.proofLifeCheckboxId === 'proofOfLife' && this.state.buttonType === 0 && !hasNoPassword) ? true : false

          let userEmailByDomain = dataItem.email ? dataItem.email : email
          let emailDomainSplit = userEmailByDomain.split('@')[1]
          let emailForbidden = true
          for (var i = 0; i < this.state.emailDomains.length; i++) {
            if (emailDomainSplit === this.state.emailDomains[i].name) {
              emailForbidden = false
              break
            }
          }
          if (!emailForbidden) {
            this.setState({ message: this.props.t('signatureRequest.pure.errorDomainInvited') })
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(true)
            this.cancel()
            return false
          }
        }
        if (this.state.buttonType === 2) {
          dataItem.type = Number(
            process.env.REACT_APP_SIGNERS_TYPE_COLABORADOR
          )
          dataItem.typeName = 'Colaborador'
          dataItem.proofOfLife = false

        }
        if (this.state.buttonType === 4) {
          dataItem.type = Number(
            process.env.REACT_APP_SIGNERS_TYPE_VALIDATOR
          )
          dataItem.typeName = 'Autorizador'
        }

        if (this.state.buttonType === 5) {
          dataItem.type = Number(
            process.env.REACT_APP_SIGNERS_TYPE_INVITADO
          )
          dataItem.typeName = 'Invitado'
          dataItem.proofOfLife = false
          dataItem.sendDocument = false
          dataItem.isSignerNoPassword = true
          dataItem.noPasswordRequired = true
          dataItem._originalNoPassword = true
        }

        if (isNewSigner) {
          if (this.state.buttonType === 4) {
            validators.unshift(this.newSigner(dataItem))
          } else {
            signers.push(this.newSigner(dataItem))
          }
        } else if (this.state.buttonType !== 4) {
          const index = signers.findIndex((p) => p.email === dataItem.email ? dataItem.email : email)
          signers.splice(index, 1, dataItem)
        } else {
          const index = validators.findIndex(
            (p) => p.email === dataItem.email ? dataItem.email : email
          )
          validators.splice(index, 1, dataItem)
        }
        this.setState({
          signers: signers,
          validators: validators,
          signerInEdit: undefined,
          userIsEditing: false,
          errorNotSigners: false,
          errorNotSigns: false,
          errorNotValidators: false,
          errorSignerType: false,
          errorCurrentName: false,
          errorCurrentLastName: false,
          listSelectedReady: true
        })
      }
    }
    else if (this.state.buttonType === 1) {// editar
      if (this.state.userIsEditing === false) {
        let currentSigners = this.state.signers
        if (currentSigners.length > 0) {
          currentSigners.forEach((signer) => {
            if (signer.email === email) {
              signerExist = true
            }
          })
          if (signerExist === true) {
            this.setState({
              errorCurrentEmailRegister: true,
              errorCurrentEmail: false,
            })
            return false
          } else {
            this.setState({
              errorCurrentEmailRegister: false,
            })
            this.state.signers.forEach((signer) => {
              if (signer.email === this.state.emailOrigin) {
                signer.email = email
              }
            })
            this.setState({
              signerInEdit: undefined,
            })
          }
        }
      }
    }
    this.cancel()
  }


  /**
  * @author Lucia Alvarado
  * @description Save data of dialog input
  * @memberof SignatureRequestProfileAction
  */
  save = async () => {
    let { nameSigner, lastNameSigner, firstLastNameSigner, secondLastNameSigner, email } = this.state.signerInEdit
    const firstName = this.state.signerInEdit.firstName
    const firstLastName = this.state.signerInEdit.firstLastName
    const secondLastName = this.state.signerInEdit.secondLastName

    // Build display name for legacy components that use nameSigner/lastNameSigner
    // but keep individual fields intact for the actual data model
    let displayNameSigner = nameSigner
    let displayLastNameSigner = lastNameSigner

    if (firstName || firstLastName || secondLastName) {
      displayNameSigner = firstName !== undefined ? firstName : nameSigner
      const parts = [firstLastName, secondLastName].filter(Boolean).map(v => String(v).trim()).filter(Boolean)
      const mappedLast = parts.join(' ')
      displayLastNameSigner = (mappedLast || lastNameSigner || '').trim()
    }

    let signerExist = false
    let signerKeys = Object.keys(this.state.signerInEdit)
    if (signerKeys.length === 0) return

    // Relaxed key-count validation: allow either legacy (3 keys) or new (email + firstName + firstLastName)
    // secondLastName is optional
    if (this.state.buttonType === 5 && signerKeys.length < 4) return
    else if (this.state.buttonType !== 5) {
      const hasLegacy = ['nameSigner', 'lastNameSigner', 'email'].every(k => signerKeys.includes(k))
      const hasNew = ['firstName', 'firstLastName', 'email'].every(k => signerKeys.includes(k))
      if (!hasLegacy && !hasNew) return
    }

    // Validate required inputs based on button type and fields present
    let hasNoInputs = false
    const requiredFields = (this.state.buttonType === 5)
      ? ['email', 'nameSigner', 'firstLastNameSigner', 'phoneNumber']
      : (firstName || firstLastName || secondLastName)
        ? ['email', 'firstName', 'firstLastName']
        : ['email', 'nameSigner', 'lastNameSigner']

    requiredFields.forEach(property => {
      const value = this.state.signerInEdit[property]
      if (value === undefined || value === null || String(value).trim() === '') {
        hasNoInputs = true
        switch (property) {
          case 'email':
            this.setState({
              errorCurrentEmail: true,
            })
            break
          case 'nameSigner':
          case 'firstName':
            this.setState({
              errorCurrentName: true
            })
            break
          case 'lastNameSigner':
            this.setState({
              errorCurrentLastName: true
            })
            break
          case 'firstLastNameSigner':
          case 'firstLastName':
            this.setState({
              errorCurrentFirstLastName: true
            })
            break
          case 'secondLastNameSigner':
          case 'secondLastName':
            this.setState({
              errorcurrentSecondLastName: true
            })
            break
          case 'phoneNumber':
            this.setState({
              errorCurrentPhoneNumber: true
            })
            break
          default:
            break
        }
      }
    })

    if (hasNoInputs) return

    // Validate name fields (secondLastName is optional, only validate if provided)
    const fieldsToValidate = (this.state.buttonType === 5)
      ? ['nameSigner', 'firstLastNameSigner']
      : (firstName || firstLastName)
        ? ['firstName', 'firstLastName']
        : ['nameSigner', 'lastNameSigner']

    fieldsToValidate.forEach(property => {
      const validate = this.validator.nameValidator(this.state.signerInEdit[property] || (property === 'lastNameSigner' ? displayLastNameSigner : displayNameSigner))
      if (validate !== '') {
        switch (property) {
          case 'nameSigner':
          case 'firstName':
            this.setState({
              errorCurrentName: true
            })
            break
          case 'lastNameSigner':
            this.setState({
              errorCurrentLastName: true
            })
            break
          case 'firstLastNameSigner':
          case 'firstLastName':
            this.setState({
              errorCurrentFirstLastName: true
            })
            break
          default:
            break
        }
      }
    })

    // Validate secondLastName only if provided (optional field)
    const secondLastNameValue = this.state.signerInEdit.secondLastName || this.state.signerInEdit.secondLastNameSigner
    if (secondLastNameValue && secondLastNameValue.trim() !== '') {
      const validate = this.validator.nameValidator(secondLastNameValue)
      if (validate !== '') {
        this.setState({
          errorcurrentSecondLastName: true
        })
        return
      }
    }
    // Validate email
    {
      const validate = this.validator.emailValidator(this.state.signerInEdit['email'])
      if (validate !== '') {
        this.setState({ errorCurrentEmail: true })
      }
    }
    // Validate phone if present
    if (this.state.signerInEdit['phoneNumber'] !== undefined) {
      const validate = isValidPhoneNumber(this.state.signerInEdit['phoneNumber'])
      if (!validate) return this.setState({ errorCurrentPhoneNumber: true })
    }

    let emailValid =
      email !== undefined &&
      email !== '' &&
      this.validator.emailValidator(email)
    if ((email === null && email === '') || emailValid !== '') {
      this.setState({
        errorCurrentEmail: true,
        errorCurrentEmailRegister: false,
      })
      return false
    } else {
      this.setState({
        errorCurrentEmail: false,
      })
    }
    if (email === '') {
      this.setState({
        errorCurrentEmailRegister: false,
      })
    }

    if (this.state.buttonType !== 1) {
      if (this.state.userIsEditing === false) {
        let currentSigners = this.state.signers

        currentSigners.forEach((signer) => {
          if (signer.email === email) {
            signerExist = true
          }
        })

        if (signerExist === true) {
          this.setState({
            errorCurrentEmailRegister: true,
            errorCurrentEmail: false,
          })
          return false
        } else {
          // Verify if users is inactive
          this.toggleLoadingRequesting(true)
          const userGovo = await this.UserService.getUserByEmail(email, this.token)
          if (userGovo && userGovo.data && userGovo.data.userSigner && !userGovo.data.userSigner.active) {
            this.setState({ message: this.props.t('signatureRequest.error.user.inactive') })
            this.toggleLoadingRequesting(false)
            this.toggleWarningRequesting(4000, this.props.t('signatureRequest.error.user.inactive'), this.props.t('signatureRequestProfileAction.dialog.title.validation.domain'))
            this.cancel()
            return false
          }

          let dataItem = { ...this.state.signerInEdit }
          if (this.state.buttonType === 5) {
            let userEmailByDomain = dataItem.email ? dataItem.email : email
            let emailDomainSplit = userEmailByDomain.split('@')[1]
            let emailForbidden = !!this.state.emailDomains.find(domain => domain.name === emailDomainSplit)
            if (emailForbidden) {
              this.setState({ message: this.props.t('signatureRequest.pure.errorDomainInvited') })
              this.toggleLoadingRequesting(false)
              this.toggleWarningRequesting(4000, this.props.t('signatureRequest.pure.errorDomainInvited'), this.props.t('signatureRequestProfileAction.dialog.title.validation.domain'))
              this.cancel()
              return false
            }

            // Set individual name fields for invited users
            dataItem.firstName = nameSigner.trim()
            dataItem.firstLastName = firstLastNameSigner.trim()
            dataItem.secondLastName = secondLastNameSigner ? secondLastNameSigner.trim() : null

            // Build display names for UI/grid
            dataItem.nameSigner = dataItem.firstName
            dataItem.lastNameSigner = [dataItem.firstLastName, dataItem.secondLastName]
              .filter(Boolean)
              .map(v => String(v).trim())
              .filter(Boolean)
              .join(' ')
            dataItem.nameCompleted = `${dataItem.nameSigner} ${dataItem.lastNameSigner}`.trim()
            dataItem.noPasswordRequired = true
            dataItem.sendDocument = true
            dataItem.isSignerNoPassword = true
          } else {
            // Set individual name fields - prioritize new values from form
            dataItem.firstName = firstName || dataItem.firstName || nameSigner || ''
            dataItem.firstLastName = firstLastName || dataItem.firstLastName || ''
            dataItem.secondLastName = secondLastName !== undefined ? secondLastName : dataItem.secondLastName || ''

            // Build display names for UI/grid
            dataItem.nameSigner = dataItem.firstName
            dataItem.lastNameSigner = [dataItem.firstLastName, dataItem.secondLastName]
              .filter(Boolean)
              .map(v => String(v).trim())
              .filter(Boolean)
              .join(' ')
            dataItem.nameCompleted = `${dataItem.nameSigner} ${dataItem.lastNameSigner}`.trim()
            dataItem.sendDocument = true
          }
          const signers = this.state.signers.slice()
          const validators = this.state.validators.slice()
          const isNewSigner = dataItem.id === undefined
          if (this.state.buttonType === 2 || this.state.buttonType === 4) {
            let userEmailByDomain = dataItem.email ? dataItem.email : email
            let emailDomainSplit = userEmailByDomain.split('@')[1]
            let emailForbidden = true

            for (var i = 0; i < this.state.emailDomains.length; i++) {
              if (emailDomainSplit === this.state.emailDomains[i].name) {
                emailForbidden = false
                break
              }
            }
            if (emailForbidden) {
              this.setState({ message: this.props.t('signatureRequest.pure.errorDomain'), messageSecond: this.props.t('signatureRequest.pure.errorDomainS'), restOfTheMessage: this.props.t('signatureRequest.pure.errorDomainAll') })
              this.toggleLoadingRequesting(false)
              // this.toggleErrorDomain(true)
              this.toggleWarningRequesting(4000, this.props.t('signatureRequest.pure.errorDomain'), this.props.t('signatureRequestProfileAction.dialog.title.validation.domain'))
              this.cancel()
              return false
            }
          }
          if (this.state.buttonType === 0) {
            let userEmailByDomain = dataItem.email ? dataItem.email : email
            let emailDomainSplit = userEmailByDomain.split('@')[1]
            let emailForbidden = true
            for (var i = 0; i < this.state.emailDomains.length; i++) {
              if (emailDomainSplit === this.state.emailDomains[i].name) {
                emailForbidden = false
                break
              }
            }
            if (!emailForbidden) {
              this.setState({ message: this.props.t('signatureRequest.pure.errorDomainInvited') })
              this.toggleLoadingRequesting(false)
              // this.toggleErrorDomainInvited(true)
              this.toggleWarningRequesting(4000, this.props.t('signatureRequest.pure.errorDomainInvited'), this.props.t('signatureRequestProfileAction.dialog.title.validation.domain'))
              this.cancel()
              return false
            }
          }
          if (this.state.buttonType === 0) {
            const hasNoPassword = dataItem.noPasswordRequired || dataItem.isSignerNoPassword || false
            const hasProofOfLife = this.state.proofLifeCheckboxId === 'proofOfLife'
            dataItem.type = Number(
              process.env.REACT_APP_SIGNERS_TYPE_INVITADO
            )
            dataItem.typeName = 'Invitado'
            dataItem.proofOfLife = hasProofOfLife && !hasNoPassword
            dataItem.noPasswordRequired = hasNoPassword
            dataItem.isSignerNoPassword = hasNoPassword
            dataItem._originalNoPassword = hasNoPassword
          }
          if (this.state.buttonType === 2) {
            const hasNoPassword = dataItem.noPasswordRequired || dataItem.isSignerNoPassword || false
            dataItem.type = Number(
              process.env.REACT_APP_SIGNERS_TYPE_COLABORADOR
            )
            dataItem.typeName = 'Colaborador'
            dataItem.noPasswordRequired = hasNoPassword
            dataItem.isSignerNoPassword = hasNoPassword
            dataItem._originalNoPassword = hasNoPassword
          }
          if (this.state.buttonType === 4) {
            dataItem.type = Number(
              process.env.REACT_APP_SIGNERS_TYPE_VALIDATOR
            )
            dataItem.typeName = 'Autorizador'
          }
          if (isNewSigner) {
            if (this.state.buttonType === 4) {
              validators.unshift(this.newSigner(dataItem))
            } else {
              signers.unshift(this.newSigner(dataItem))
            }
          } else if (this.state.buttonType !== 4) {
            const index = signers.findIndex((p) => p.email === dataItem.email)
            signers.splice(index, 1, dataItem)
          } else {
            const index = validators.findIndex(
              (p) => p.email === dataItem.email
            )
            validators.splice(index, 1, dataItem)
          }
          setTimeout(() => {
            this.toggleLoadingRequesting(false)
            this.setState({
              signers: signers,
              validators: validators,
              signerInEdit: undefined,
              userIsEditing: false,
              errorNotSigners: false,
              errorNotSigns: false,
              errorNotValidators: false,
              errorSignerType: false,
              errorCurrentName: false,
              errorCurrentLastName: false,
              errorCurrentEmailRegister: false
            })
          }, [3000])
        }
      }
    } else if (this.state.buttonType === 1) {// editar
      if (this.state.userIsEditing === false) {
        let currentSigners = this.state.signers
        if (currentSigners.length > 0) {
          currentSigners.forEach((signer) => {
            if (signer.email === email) {
              signerExist = true
            }
          })
          if (signerExist === true) {
            this.setState({
              errorCurrentEmailRegister: true,
              errorCurrentEmail: false,
            })
            return false
          } else {
            this.setState({
              errorCurrentEmailRegister: false,
            })
            this.state.signers.forEach((signer) => {
              if (signer.email === this.state.emailOrigin) {
                signer.email = email
              }
            })
            this.setState({
              signerInEdit: undefined,
            })
          }
        }
      }
    }
    this.cancel()
  }

  /**
   * @author Adrian Montemayor
   * @description Confirm data of domain
   * @memberof SignatureRequestProfileAction
   */
  confirm = async () => {
    let dataItem = this.state.signerInEdit

    const signers = this.state.signers.slice()
    const validators = this.state.validators.slice()
    const isNewSigner = dataItem.id === undefined
    if (isNewSigner) {
      if (this.state.buttonType === 4) {
        validators.unshift(this.newSigner(dataItem))
      } else {
        signers.unshift(this.newSigner(dataItem))
      }
    } else if (this.state.buttonType !== 4) {
      const index = signers.findIndex((p) => p.email === dataItem.email)
      signers.splice(index, 1, dataItem)
    } else {
      const index = validators.findIndex(
        (p) => p.email === dataItem.email
      )
      validators.splice(index, 1, dataItem)
    }
    this.setState({
      signers: signers,
      validators: validators,
      signerInEdit: undefined,
      userIsEditing: false,
      errorNotSigners: false,
      errorNotSigns: false,
      errorNotValidators: false,
      errorSignerType: false,
      errorCurrentName: false,
      errorCurrentLastName: false,
      showErrorDomainInvited: false,
    })
  }

  /**
   * @author Lucia Alvarado
   * @description Edit a signer
   * @param {Object} dataItem
   * @memberof SignatureRequestProfileAction
   */
  edit = (dataItem) => {
    this.setState({
      emailOrigin: dataItem.email,
      signerInEdit: this.cloneSigner(dataItem),
      // userIsEditing: true,
      buttonType: 1,
    })
  }


  /**
   * @author Lucia Alvarado
   * @description Duplicate data signer for the grid
   * @param {Object} signer
   * @memberof SignatureRequestProfileAction
   */
  cloneSigner(signer) {
    return Object.assign({}, signer)
  }

  /**
  * @author Lucia Alvarado
  * @description Remove a signer of grid
  * @memberof SignatureRequestAction
  */
  remove = () => {
    let params = {
      visibleDialogDeleteSigner: false,
      signerToDelete: '',
    }
    if (this.state.signerToDelete.is === 'signer')
      params.signers = this.state.signers.filter(
        (p) => p.email !== this.state.signerToDelete.email
      )
    if (this.state.signerToDelete.is === 'validator')
      params.validators = this.state.validators.filter(
        (p) => p.email !== this.state.signerToDelete.email
      )
    this.setState(params)
    this.setState({ deletedSignatures: true })
  }

  /**
 * @author Lucia Alvarado
 * @description Method to clear and hide dialog
 * @memberof SignatureRequestProfileAction
 */
  cancel = () => {
    this.setState({
      signerInEdit: undefined,
      // disableSignerButton: true,
      errorCurrentEmail: false,
      errorCurrentEmailRegister: false,
      errorSignerType: false,
      errorCurrentName: false,
      errorCurrentLastName: false,
      showErrorDomainInvited: false,
      showDialogList: false
    })
  }

  /**
   * @author Lucia Alvarado
   * @description Method to change the signerTypeSelected in combobox
   * @param {Event} event
   * @memberof SignatureRequestProfileAction
  */
  onChangeCombobox = (event) => {
    this.setState({
      signerTypesSelected: event.target.value,
    })
  }

  /**
 * @author Leonel Contreras
 * @description Add eventId generation
 * @param {*} event
 */
  handleChangeCheckbox = (event) => {
    let eventId = hash({ hash: Math.random().toString(36).substring(7) })
    this.setState({
      documentAccept: event.target.checked,
      eventId,
    })
  }

  handleChangeCheckboxTF = (event) => {
    this.setState({
      firmante: event.value,
    })
  }

  /**
  * @author Lucia Alvarado
  * @description Change the title dialog
  * @param {Event} event
  * @memberof SignatureRequestProfileAction
  */
  dialogTitle() {
    return `${this.state.signerInEdit.id === undefined ? 'Agregar firmante' : 'Edit'
      } product`
  }


  /**
   * @author Lucia Alvarado
   * @description Method to save form of the dialog add new collaborator
   * @param {Event} event
   * @memberof SignatureRequestProfileAction
   */
  handleSubmit = () => {
    this.save()
    // this.setState({ disableSignerButton: true })
  }

  /**
 * @author Lucia Alvarado
 * @description Change the list with selected users from gridSelected
 * @param {Object} dataItem
 * @date 01-09-2023
 * @memberof SignatureRequestProfileAction
 */
  saveArraSelectedList = (arraySelected, usersGridNotSelected, listCompleted) => {
    this.setState({
      arraySelectedGridList: arraySelected,
      arrayNotSelectedGridList: usersGridNotSelected,
    })
  }

  /**
 * @author Lucia Alvarado
 * @description Method to save user selected from grid dialog
 * @param {Object} dataItem
 * @memberof SignatureRequestProfileAction
 */
  handleSubmitList = () => {
    if (this.state.arraySelectedGridList.length > 0 && this.state.showDialogList === true) {
      let formatedArray = this.state.arraySelectedGridList.map((user) => {
        const lastNameSigner = [user.firstLastName, user.secondLastName].filter(Boolean).join(' ').trim()
        return {
          nameSigner: user.firstName,
          lastNameSigner: lastNameSigner,
          firstName: user.firstName,
          firstLastName: user.firstLastName,
          secondLastName: user.secondLastName,
          email: user.email,
          noPasswordRequired: user.noPasswordRequired,
          isSignerNoPassword: user.noPasswordRequired ?? user.isSignerNoPassword ?? false
        }
      })
      formatedArray.forEach((element) => {
        let { nameSigner, lastNameSigner, email, noPasswordRequired, isSignerNoPassword, firstName, firstLastName, secondLastName } = element
        this.validateSave(nameSigner, lastNameSigner, email, noPasswordRequired, isSignerNoPassword, firstName, firstLastName, secondLastName)
      })
    }
  }

  /**
 * @author Lucia Alvarado
 * @description Method to save form of the dialog notification
 * @param {Event} event
 * @memberof SignatureRequestProfileAction
 */
  handleSubmitConfirm = (event) => {
    event.preventDefault()
    this.confirm()
    // this.setState({ disableSignerButton: true })
  }

  /**
 * @author Lucia Alvarado
 * @description Method to change the data of form dialog
 * @updatedDate 24-08-23
 * @param {Event} event
 * @memberof SignatureRequestProfileAction
 */

  onDialogInputChange = async (event) => {
    this.setState({
      autocomplete: false,
      firstLastName: '',
      firstName: '',
      getUserNameFilter: {},
    })
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value
    const name = event.target.props ? event.target.props.name : event.target.name

    const edited = this.state.signerInEdit
    edited[name] = value
    if (name === 'numSign') {
      edited[name] = value > 99 ? 99 : value
    }
    // if (edited.email === '') {
    //   edited.nameSigner = ''
    //   edited.lastNameSigner = ''
    // }
    this.setState({
      signerInEdit: edited,
    })

    let nameValid = ''
    if (name === 'nameSigner') nameValid = this.validator.nameValidator(value)

    if (this.state.signerInEdit.nameSigner !== null && nameValid === '') {
      this.setState({
        errorCurrentName: false,
        // disableSignerButton: false,
        autocomplete: true,
      })
    } else {
      this.setState({
        errorCurrentName: true,
        // disableSignerButton: true,
      })
    }
    let firstLastName = ''
    if (name === 'firstLastNameSigner') firstLastName = this.validator.nameValidator(value)

    let secondLastName = ''
    if (name === 'secondLastNameSigner') secondLastName = this.validator.nameValidator(value)

    if (
      this.state.signerInEdit.firstLastName !== null &&
      firstLastName === ''
    ) {
      this.setState({
        errorCurrentLastName: false,
        // disableSignerButton: false,
        autocomplete: false,
      })
    } else {
      this.setState({
        errorCurrentLastName: true,
        // disableSignerButton: true,
      })
    }

    if (
      this.state.signerInEdit.secondLastName !== null &&
      secondLastName === ''
    ) {
      this.setState({
        errorCurrentLastName: false,
        // disableSignerButton: false,
        autocomplete: false,
      })
    } else {
      this.setState({
        errorCurrentLastName: true,
        // disableSignerButton: true,
      })
    }

    // if (
    //   this.state.signerInEdit.lastNameSigner !== null &&
    //   firstLastName === ''
    // ) {
    //   this.setState({
    //     errorCurrentLastName: false,
    //     // disableSignerButton: false,
    //     autocomplete: false,
    //   })
    // } else {
    //   this.setState({
    //     errorCurrentLastName: true,
    //     // disableSignerButton: true,
    //   })
    // }

    try {
      if (name === 'email')
        if (
          this.state.signerInEdit.email !== null &&
          this.validator.emailValidator(this.state.signerInEdit.email) === ''
        ) {
          this.setState({
            errorCurrentEmail: false,
            // disableSignerButton: false,
            autocomplete: true,
          })
          if (!this.state.getUserEmailFilterLoading) {
            this.state.getUserEmailFilter.forEach((item) => {
              if (item === value) {
                this.getUserName(item)
                //if(!this.state.getUserNameFilterLoading){

                // Set individual name fields
                edited.firstName = this.state.getUserNameFilter.firstName
                edited.firstLastName = this.state.getUserNameFilter.firstLastName
                edited.secondLastName = this.state.getUserNameFilter.secondLastName

                // Set legacy display fields
                edited.nameSigner = this.state.getUserNameFilter.firstName
                edited.lastNameSigner = [
                  this.state.getUserNameFilter.firstLastName,
                  this.state.getUserNameFilter.secondLastName
                ].filter(Boolean).map(v => String(v).trim()).filter(Boolean).join(' ')

                this.setState({
                  firstLastName: this.state.getUserNameFilter.firstLastName,
                  firstName: this.state.getUserNameFilter.firstName,
                  getEmail: this.state.getUserNameFilter.email,
                })
                //}
              }
            })
          }
        } else {
          this.setState({
            errorCurrentEmail: true,
            // disableSignerButton: true,
            autocomplete: false,
          })
        }
    } catch (error) { }

    // if(this.state.signerInEdit.signerTypeSelected !== null){
    //   this.setState({
    //     errorSignerType: false,
    //     disableSignerButton: false
    //   })
    // } else {
    //   this.setState({
    //     errorSignerType: true,
    //     disableSignerButton: true
    //   })
    // }
  }

  /**
   * @param {string} phoneNumber
   * @memberof SignatureRequestProfileAction
   */
  onChangePhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return
    const signerEditing = { ...this.state.signerInEdit }

    signerEditing.phoneNumber = phoneNumber
    this.setState({
      signerInEdit: signerEditing
    })
  }


  getUserEmail = async (value) => {
    this.setState({
      loadingAutoComplete: true,
      getUserEmailFilterLoading: true,
    })
    //let getUserEmailFilter = await this.UserService.getUserEmail(value, this.token)
    let getUserEmailFilter = await this.UserService.getInvitados(
      value,
      this.token
    )
    this.setState({
      getUserEmailFilterLoading: false,
      getUserEmailFilter,
      loadingAutoComplete: false,
    })
  }

  getUserName = async (value) => {
    const edited = this.state.signerInEdit
    //this.setState({ getUserNameFilterLoading: true })
    const arrayNames = []
    let getUserNameFilter = await this.UserService.getUserName(
      value,
      this.token
    )
    this.setState({ getUserNameFilterLoading: false, getUserNameFilter })
    let id = 0
    if (this.state.signers.length > 0) {
      const element = this.state.signers[0].id_order

      id = element + 1
    }

    // Set individual name fields
    edited.firstName = getUserNameFilter ? getUserNameFilter.firstName : ''
    edited.firstLastName = getUserNameFilter ? getUserNameFilter.firstLastName : ''
    edited.secondLastName = getUserNameFilter ? getUserNameFilter.secondLastName : ''

    // Set legacy display fields for compatibility
    edited.nameSigner = edited.firstName
    edited.lastNameSigner = [edited.firstLastName, edited.secondLastName]
      .filter(Boolean)
      .map(v => String(v).trim())
      .filter(Boolean)
      .join(' ')

    edited.type = 3
    edited.typeName = 'Invitado'
    edited.id_order = id
    this.setState({
      signerInEdit: edited,
    })
    arrayNames.push(getUserNameFilter)
  }

  getCollaborator = async (value) => {
    this.setState({ getCollaboratorLoading: true })
    let getUserNameFilter = await this.UserService.getCollaborator(
      value,
      this.token
    )
    this.setState({
      getCollaboratorLoading: false,
      getCollaboratorFilter: getUserNameFilter,
    })
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.processTypesInputValue !== prevState.processTypesInputValue
    ) {
      let processType =
        this.state.processTypesInputValue.find((item) => item.isActive) ?? {}
      let processTypeId = this.state.processTypeId || processType?.id
      this.setState({ processTypeId: processTypeId })
    }
    if (this.state.getUserNameFilter !== prevState.getUserNameFilter) {
      if (!this.state.getUserNameFilterLoading) {
      }
    }
    if (this.state.firmante !== prevState.firmante) {
      if (!this.state.firmante) {
        for (var i = 0; i < this.state.signers.length; i++) {
          if (this.state.signers[i].email === this.state.userInformationEmail) {
            this.state.signers.splice(i, 1)
            this.setState({ signers: this.state.signers })
            break
          }
        }
      }
    }
  }

  /* ====== START - HANDLER METHODS FOR DISPLAY PDF ====== */

  pdfToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
      reader.onerror = (error) => reject(error)
    })

  /**
 * @author Alan Aguilar
 * @description Method to get the file
 * @param {import("react").ChangeEvent<HTMLInputElement>} e
 * @memberof SignatureRequestProfileAction
 */
  handleFile = async (e) => {
    if (e && typeof e.preventDefault === 'function') {
      e.preventDefault()
    }
    const file = e?.target?.files?.[0]
    if (!file) return

    let result = file.name.slice(-4)
    if (result === '.pdf' || result === '.PDF') {
      await this.toggleLoadingRequesting(true)

      try {
        const formData = new FormData()
        formData.append('file', file)

        const validationResult = await this.documentValidationService.hasSignatures(this.token, formData)
        const isValidResponse = validationResult.statusCode === 200
        const documentAlreadySigned = validationResult?.data?.hasSignatures

        if (isValidResponse && documentAlreadySigned) {
          this.toggleLoadingRequesting(false)
          return this.toggleWarningRequesting(
            4000,
            <span>
              {this.props.t('signatureRequestProfileAction.validation.dialog.message.pt1')}{' '}
              <strong>{this.props.t('signatureRequestProfileAction.validation.dialog.message.pt2')}</strong>.{' '}
              {this.props.t('signatureRequestProfileAction.validation.dialog.message.pt3')}{' '}
              <strong>{this.props.t('signatureRequestProfileAction.validation.dialog.message.pt4')}</strong>{' '}
              {this.props.t('signatureRequestProfileAction.validation.dialog.message.pt5')}
            </span>,
            this.props.t('signatureRequestProfileAction.validation.dialog.title')
          )
        }
      } catch (error) {
        this.toggleLoadingRequesting(false)
        return this.toggleErrorRequesting(true)
      }

      this.setState({
        selectedFileName: file.name,
        errorFile: false,
        colorBorderContainer: 'green',
      })
      let fileBase64 = await this.pdfToBase64(file)

      let pdfDoc = await PDFDocument.load(fileBase64)
      const { hadError, PDFDocument: pdfReturned } = PDFUtil.fixPageType(pdfDoc)
      pdfDoc = pdfReturned
      if (hadError) {
        fileBase64 = await pdfDoc.saveAsBase64()
      }

      const author = pdfDoc.getAuthor()
      const creator = pdfDoc.getCreator()
      const pages = pdfDoc.getPageCount()

      let fileSplitted
      if ((creator === 'Form ZSMMM_ORD_COMPRA ES' && pages <= 35) || (creator === '' && author === '' && pages <= 35)) {
        let data = new FormData()
        data.append('doc', file)
        let pdfConverted = await this.convertDocumentService.convertDocumentPDF(this.token, data)
        const convertedBlob = new Blob([new Uint8Array(pdfConverted.data).buffer], { type: 'application/pdfbase64' })
        let convertedBase64 = await this.pdfToBase64(convertedBlob)
        fileSplitted = convertedBase64.split(',')[1]
        this.setState({ exportPdf: true })
      }
      let pdfBase64
      let selectedFile
      if (hadError) {
        pdfBase64 = fileBase64
        const fileArrayInt = await pdfDoc.save()
        const fileBlob = new Blob([fileArrayInt.buffer])
        selectedFile = new File([fileBlob], file.name)
      } else {
        pdfBase64 = fileBase64.split(',')[1]
      }

      this.setState({ selectedFileBase64: fileSplitted ?? pdfBase64, selectedFile: selectedFile ?? file })
      await this.toggleLoadingRequesting(false)
    } else {
      this.setState({
        selectedFile: null,
        errorFile: true,
        selectedFileBase64: '',
        colorBorderContainer: 'gray',
      })
      return false
    }
  }

  handleDeleteFile = (e) => {
    this.setState({
      selectedFile: null,
      errorFile: false,
      deletePfd: true,
      selectedFileBase64: '',
      colorBorderContainer: 'gray',
    })
    return true
  }

  /**
   * @author Alan Aguilar
   * @description Method to show file
   * @memberof SignatureRequestProfileAction
   */
  onDocumentLoadSuccess = ({ numPages }) => {
    this.setState({ numPages })
    this.setState({ pageNumber: 1 })
    this.setState({ errorFile: false })
    this.fillPagesArray(numPages)
  }

  /**
   * @author Alan Aguilar
   * @description Method to add page of the file
   * @memberof SignatureRequestProfileAction
   */
  fillPagesArray = (numPages) => {
    let pages = []
    for (let i = 1; i <= numPages; i++) {
      pages.push(i)
    }
    // this.setState({ pagesArray: pages })

    let optionsRendered = pages.map((item, index) => {
      return (
        <option key={index} value={item}>
          {item}
        </option>
      )
    })
    this.setState({ pagesArray: optionsRendered })
  }

  /**
   * @author Alan Aguilar
   * @description Method to go to the page selected
   * @param {Event} event
   * @memberof SignatureRequestProfileAction
   */
  goToSelectPage = (event) => {
    let pageSelected = event.target.value
    this.setState({ pageNumber: Number(pageSelected) })
  }
  /**
   * @author Alan Aguilar
   * @description Method to go to the page before
   * @memberof SignatureRequestProfileAction
   */
  goToPrevPage = () => {
    if (this.state.numPages === null || this.state.pageNumber === 1) return
    let prevPage = this.state.pageNumber - 1
    this.setState({ pageNumber: prevPage })
  }

  /**
   * @author Alan Aguilar
   * @description Method to go to the next page
   * @memberof SignatureRequestProfileAction
   */
  goToNextPage = () => {
    if (
      this.state.numPages === null ||
      this.state.pageNumber >= this.state.numPages
    )
      return
    let nextPage = this.state.pageNumber + 1
    this.setState({ pageNumber: nextPage })
  }

  /**
   * @author Alan Aguilar
   * @description Method to zoom page selected
   * @memberof SignatureRequestProfileAction
   */
  onZoomIn = () => {
    if (this.state.numPages === null) return
    let addZoom = this.state.zoom + 0.5
    this.setState({ zoom: addZoom })
  }

  /**
   * @author  Alan Aguilar
   * @description Method to zoom out page selected
   * @memberof SignatureRequestProfileAction
   */
  onZoomOut = () => {
    if (this.state.numPages === null) return
    let removeZoom = this.state.zoom - 0.5
    this.setState({ zoom: removeZoom })
  }

  /* ====== END - HANDLER METHODS FOR DISPLAY PDF ====== */

  /**
* @author Alan Aguilar
* @description Method to save the name of the signRequest
* @updatedDate 06-04-2022
* @memberof SignatureRequestProfileAction
*/
  onChangeNameSignature = (e) => {
    this.setState({ nameSignature: e.target.value })
    let nameSignatureValid = this.validator.nameValidator(e.target.value)
    let errorCurrentNameSignature = (nameSignatureValid && nameSignatureValid !== '') ? true : false
    let errorMessageCurrentNameSignature = (errorCurrentNameSignature === true) ? nameSignatureValid : ''
    this.setState({ errorCurrentNameSignature, errorMessageCurrentNameSignature })
  }

  /**
  * @author Alan Aguilar
  * @description Method to save the summary of the signRequest
  * @updatedDate 06-04-2022
  * @memberof SignatureRequestProfileAction
  */
  onChangeSummaryDescription = (e) => {
    this.setState({ description: e.target.value })
    // let descriptionValid = this.validator.descriptionValidator(e.target.value)
    // let errorCurrentDescription = (descriptionValid && descriptionValid !== '') ? true : false
    // let errorMessageCurrentDescription = (errorCurrentDescription === true) ? descriptionValid : ''
    // this.setState({ errorCurrentDescription, errorMessageCurrentDescription })
  }

  /**
  * @author Alan Aguilar
  * @description Method to save the comments if the signRequest
  * @updatedDate 06-04-2022
  * @memberof SignatureRequestProfileAction
  */
  onChangeComments = (e) => {
    this.setState({ comments: e.target.value })
    // let commentsValid = this.validator.commentsValidator(e.target.value)
    // let errorCurrentComments = (commentsValid && commentsValid !== '') ? true : false
    // let errorMessageCurrentComments = (errorCurrentComments === true) ? commentsValid : ''
    // this.setState({ errorCurrentComments, errorMessageCurrentComments })
  }

  /**
  * @author Alan Aguilar
  * @description Method to validate name, description (resume) and comments in Profile Data
  * @updatedDate 06-04-2022
  * @memberof SignatureRequestProfileAction
  */
  onValidateProfileData = () => {
    const { nameSignature, comments, errorCurrentNameSignature, errorCurrentComments } = this.state
    let [emptyName, emptyComments] = [false, false]

    if (!nameSignature || nameSignature.trim() === '' || nameSignature.length <= 0) {
      emptyName = true
      this.setState({ errorCurrentNameSignature: true, errorMessageCurrentNameSignature: this.props.t('signatureRequestProfileData.nameSignature') })
    }

    // if (!comments || comments.trim() === '' || comments.length <= 0) {
    //   emptyComments = true
    //   this.setState({ errorCurrentComments: true, errorMessageCurrentComments: this.props.t('signatureRequestProfileData.notes') })
    // }

    if (emptyName === true || !this.state.selectedFile || !this.state.documentAccept) return false
    if (errorCurrentNameSignature === true) return false
    // if (errorCurrentComments === true) return false

    this.setState({
      errorCurrentNameSignature: false,
      errorCurrentDescription: false,
      errorCurrentComments: false,
      errorMessageCurrentNameSignature: '',
      errorMessageCurrentDescription: '',
      errorMessageCurrentComments: ''
    })
    return true
    // this.onNextStep()

    // const { nameSignature, errorCurrentNameSignature, errorCurrentDescription, errorCurrentComments } = this.state
    // let [emptyName] = [false]
    // if (!nameSignature || nameSignature.trim() === '' || nameSignature.length <= 0) {
    //   emptyName = true
    //   this.setState({ errorCurrentNameSignature: true, errorMessageCurrentNameSignature: this.props.t('signatureRequestProfileData.nameSignature') })
    // }

    // if (emptyName === true) return false
    // if (errorCurrentNameSignature === true || errorCurrentDescription === true || errorCurrentComments === true) return false

    // this.setState({
    //   errorCurrentNameSignature: false,
    //   errorCurrentDescription: false,
    //   errorCurrentComments: false,
    //   errorMessageCurrentNameSignature: '',
    //   errorMessageCurrentDescription: '',
    //   errorMessageCurrentComments: ''
    // })
    // this.onNextStep()
  }

  insertSignaturesBySigner = (signature) => {
    let { x, y, page } = signature
    let { signers } = this.state
    let signersCopy = [...signers]
    let signer = [...signersCopy.filter((signer) => signer.email === signature.email)]
    if (signer[0].hasOwnProperty('coordinates') && signer[0].coordinates.hasOwnProperty('data')) {
      signer[0].coordinates.data.push({ x, y, page })
      this.setState({ signers: signersCopy })
    } else {
      signer[0].coordinates = {}
      signer[0].coordinates.data = []
      signer[0].coordinates.data.push({ x, y, page })
      this.setState({ signers: signersCopy })
    }
    this.setState({ signers: signersCopy })
  }

  /**
   * @author  Lucia Alvarado
   * @description Method to move scroll
   * @memberof SignatureRequestProfileAction
   */
  scrollWindow = () => {
    window.scrollTo(0, 0)
  }

  /**
   * @author Lucia Alvarado
   * @description Handle the submit event
   * @param {Event} event
   * @memberof SignatureRequestProfileAction
   */
  onSubmit = async (dataItem) => {
    // e.preventDefault()
    this.setState({ message: null })
    let {
      nameSignature,
      date,
      description,
      comments,
      documentAccept,
      eventId,
      servicesId,
      signatureTypeId,
      processTypeId,
      // signers,
      requireSignSupport,
      selectedFile,
      timezone
    } = this.state
    if (this.state.errorCurrentNameSignature === true) {
      return false
    }
    if (this.state.errorCurrentDescription === true) {
      return false
    }
    // if (this.state.errorCurrentComments === true) {
    //   return false
    // }
    if (this.state.selectedFile === null) {
      this.setState({ errorFile: true })
      return false
    } else {
      this.setState({ errorFile: false })
    }
    let result = this.state.selectedFile.name.slice(-4)
    if (result.toLowerCase() !== '.pdf') {
      this.setState({ errorFile: true })
      return false
    } else {
      this.setState({ errorFile: false })
    }
    let signatureType = this.state.signatureTypesInputValue.find((item) => item.isActive) ?? {}
    let signatureTypeIdExist = signatureTypeId || signatureType?.id
    if (!signatureTypeIdExist) {
      await this.toggleErrorRequesting(true)

      // this.setState({ errorSignatureTypeId: true })
      return false
    }
    let processType = this.state.processTypesInputValue.find((item) => item.isActive) ?? {}
    let processTypeIdNew = this.state.processTypeId || processType?.id
    if (!processTypeIdNew) {
      this.setState({ errorProcessTypeId: true })
      return false
    }
    if (this.state.documentAccept === false) {
      this.setState({ errorAcceptDocument: true })
      return false
    } else {
      this.setState({ errorAcceptDocument: false })
    }
    if (this.state.signers.length <= 0) {
      this.setState({ errorNotSigners: false })
      return false
    } else {
      this.setState({
        errorNotSigners: false,
      })
    }
    if (
      this.state.validators.length <= 0 &&
      (this.state.processTypeId ===
        Number(process.env.REACT_APP_SIGNERS_PROCESS_TYPE_APPROVAL) ||
        this.state.processTypeId ===
        Number(
          process.env.REACT_APP_SIGNERS_PROCESS_TYPE_SEQUENTIAL_APPROVAL
        ))
    ) {
      this.setState({
        message: this.props.t('signatureRequestAction2.notAuthorizers')
      })
      this.toggleErrorRequesting(true)
      return false
    } else {
      this.setState({ errorNotValidators: false })
    }
    if (this.state.notification === true) this.onCloseOpenModal()
    try {
      await this.toggleLoadingRequesting(true)
      // Eliminar el nombre y apellido completo del valor nameSigner
      this.state.signers.map(signer => {
        if (this.state.signatureTypeId === process.env.REACT_APP_SIGNATURE_TYPE_AUTOGRAFA) {
          let newCoordinates = signer.coordinates.data.sort(function (a, b) {
            return a.page - b.page || b.y - a.y
          })
          signer.coordinates.data = newCoordinates
        }
      })
      const mapLegacySigner = (s) => {

        // Get individual name parts and send them separately to backend
        const firstName = s.firstName || s.nameSigner || ''
        const firstLastName = s.firstLastName || s.firstLastNameSigner || ''
        const secondLastName = s.secondLastName || s.secondLastNameSigner || ''

        const result = {
          firstName,
          firstLastName,
          secondLastName: secondLastName || null
        }

        return result
      }

      if (
        String(this.state.processTypeId) ===
        String(process.env.REACT_APP_SIGNERS_PROCESS_TYPE_RANDOM)
      ) {
        dataItem.signers = this.state.signers.map((signer) => {
          const hasNoPassword = signer.noPasswordRequired || signer.isSignerNoPassword || false
          const hasProofOfLife = signer.proofOfLife || false
          const shouldBeNoPassword = hasNoPassword && !hasProofOfLife
          return {
            // ...signer,
            email: signer.email,
            ...mapLegacySigner(signer),
            numSign: signer.numSign,
            coordinates: signer.coordinates,
            signerTypeId:
              signer.type ?? Number(process.env.REACT_APP_SIGNERS_TYPE_INVITADO),
            signerEvent: {
              signerEventTypeId: Number(
                process.env.REACT_APP_SIGNER_EVENT_TYPE_SOLICITUD
              ),
              eventId: 1,
            },
            sendDocument: signer.sendDocument,
            noPasswordRequired: shouldBeNoPassword,
            isSignerNoPassword: shouldBeNoPassword,
            phoneNumber: signer.phoneNumber,
            proofOfLife: hasProofOfLife,
            languageId: signer.languageId || 1
          }
        })
        eventId = 1
      }
      if (
        String(this.state.processTypeId) ===
        String(process.env.REACT_APP_SIGNERS_PROCESS_TYPE_SEQUENTIAL)
      ) {
        dataItem.signers = this.state.signers.map((signer, index) => {
          const hasNoPassword = signer.noPasswordRequired || signer.isSignerNoPassword || false
          const hasProofOfLife = signer.proofOfLife || false
          const shouldBeNoPassword = hasNoPassword && !hasProofOfLife
          return {
            // ...signer,
            email: signer.email,
            numSign: signer.numSign,
            coordinates: signer.coordinates,
            ...mapLegacySigner(signer),
            signerTypeId:
              signer.type ?? Number(process.env.REACT_APP_SIGNERS_TYPE_INVITADO),
            order: index + 1,
            signerEvent: {
              signerEventTypeId: Number(
                process.env.REACT_APP_SIGNER_EVENT_TYPE_SOLICITUD
              ),
              eventId: 1,
            },
            sendDocument: signer.sendDocument,
            phoneNumber: signer.phoneNumber,
            isSignerNoPassword: shouldBeNoPassword,
            proofOfLife: hasProofOfLife,
            languageId: signer.languageId || 1
          }
        })
        eventId = 1
      }
      if (
        String(this.state.processTypeId) ===
        String(process.env.REACT_APP_SIGNERS_PROCESS_TYPE_APPROVAL)
      ) {
        let tempSigners = this.state.signers.map((signer) => {
          const hasNoPassword = signer.noPasswordRequired || signer.isSignerNoPassword || false
          const hasProofOfLife = signer.proofOfLife || false
          const shouldBeNoPassword = hasNoPassword && !hasProofOfLife
          return {
            // ...signer,
            email: signer.email,
            numSign: signer.numSign,
            ...mapLegacySigner(signer),
            coordinates: signer.coordinates,
            signerTypeId:
              signer.type ?? Number(process.env.REACT_APP_SIGNERS_TYPE_INVITADO),
            signerEvent: {
              signerEventTypeId: Number(
                process.env.REACT_APP_SIGNER_EVENT_TYPE_SOLICITUD
              ),
              eventId: 1,
            },
            sendDocument: signer.sendDocument,
            phoneNumber: signer.phoneNumber,
            isSignerNoPassword: shouldBeNoPassword,
            proofOfLife: hasProofOfLife,
            languageId: signer.languageId || 1
          }
        })
        let tempValidators = this.state.validators.map((signer) => ({
          // ...signer,
          email: signer.email,
          ...mapLegacySigner(signer),
          signerTypeId: signer.type,
          signerEvent: {
            signerEventTypeId: Number(
              process.env.REACT_APP_SIGNER_EVENT_TYPE_SOLICITUD
            ),
            eventId: 1,
          },
          sendDocument: signer.sendDocument,
          phoneNumber: signer.phoneNumber,
          languageId: signer.languageId || 1
        }))
        dataItem.signers = tempSigners.concat(tempValidators)
        eventId = 1
      }
      if (
        String(this.state.processTypeId) ===
        String(process.env.REACT_APP_SIGNERS_PROCESS_TYPE_SEQUENTIAL_APPROVAL)
      ) {
        let tempSigners = this.state.signers.map((signer, index) => {
          const hasNoPassword = signer.noPasswordRequired || signer.isSignerNoPassword || false
          const hasProofOfLife = signer.proofOfLife || false
          const shouldBeNoPassword = hasNoPassword && !hasProofOfLife
          return {
            // ...signer,
            email: signer.email,
            numSign: signer.numSign,
            coordinates: signer.coordinates,
            ...mapLegacySigner(signer),
            signerTypeId:
              signer.type ?? Number(process.env.REACT_APP_SIGNERS_TYPE_INVITADO),
            order: index + 1,
            signerEvent: {
              signerEventTypeId: Number(
                process.env.REACT_APP_SIGNER_EVENT_TYPE_SOLICITUD
              ),
              eventId: 1,
            },
            sendDocument: signer.sendDocument,
            isSignerNoPassword: shouldBeNoPassword,
            phoneNumber: signer.phoneNumber,
            proofOfLife: hasProofOfLife,
            languageId: signer.languageId || 1
          }
        })
        let tempValidators = this.state.validators.map((signer, index) => ({
          // ...signer,
          email: signer.email,
          ...mapLegacySigner(signer),
          signerTypeId: signer.type,
          order: index + 1,
          signerEvent: {
            signerEventTypeId: Number(
              process.env.REACT_APP_SIGNER_EVENT_TYPE_SOLICITUD
            ),
            eventId: 1,
          },
          languageId: signer.languageId || 1
        }))
        dataItem.signers = tempSigners.concat(tempValidators)
        eventId = 1
      }
      // let { signers } = dataItem.signers
      // signers = this.state.signers.map((item) => {
      //   let current = this.state.signers.find(i => i.email === item.email)
      //   if (current) {
      //     return {
      //       ...item,
      //       numSign: current.numSign
      //     }
      //   }
      //   return item
      // })
      // Generate Array servicesId
      // let servicesId = services 
      //   .filter((i) => i.isActive)
      //   .map((i) => i.id)

      let workflowExecutionId = this.state.contractFromNegotiation && this.state.contractFromNegotiation.workflowExecutionId ? this.state.contractFromNegotiation.workflowExecutionId : ''
      let awsUrl = this.state.contractFromNegotiation && this.state.contractFromNegotiation.url ? this.state.contractFromNegotiation.url : ''

      const hasSubcategory = Number(this.state.subCategoryIdSelected) > 0
      const dataClassifier = {
        companyId: this.state.companyIdSelected,
        categoryId: hasSubcategory ? this.state.categoryIdSelected : 0,
        subCategoryId: hasSubcategory ? this.state.subCategoryIdSelected : 0,
        typeDocument: this.state.typeDocumentSelected,
        pathBreadcrumb: hasSubcategory ? this.state.pathBreadcrumbSelected : ''
      }

      let signRequestBody = new FormData()
      signRequestBody.append('name', nameSignature)
      signRequestBody.append('description', description)
      signRequestBody.append('comments', comments)
      signRequestBody.append('eventId', eventId)
      signRequestBody.append('signers', JSON.stringify(dataItem.signers))
      signRequestBody.append('limitDate', date)
      signRequestBody.append('documentAccept', documentAccept)
      signRequestBody.append('signatureTypeId', signatureTypeId)
      signRequestBody.append('servicesId', JSON.stringify(servicesId))
      signRequestBody.append('processTypeId', processTypeId)
      signRequestBody.append('requireSignSupport', requireSignSupport)
      signRequestBody.append('file', selectedFile)
      signRequestBody.append('timezone', timezone)
      signRequestBody.append('workflowExecutionId', workflowExecutionId)
      signRequestBody.append('awsUrl', awsUrl)
      signRequestBody.append('exportPdf', this.state.exportPdf)
      signRequestBody.append('watermarkActive', this.state.watermarkActive)
      signRequestBody.append('dataClassifier', JSON.stringify(dataClassifier))

      const signRequest = await this.signatureRequestService.createSignatureRequest(signRequestBody, this.token)
      if (signRequest && signRequest.statusCode === 200) {
        this.cache.deleteUrlFromCache('/users-collaborators-invites')
        await this.toggleLoadingRequesting(false)
        await this.toggleCompletedRequesting(true)
        return true
      } else {
        switch (signRequest.statusCode) {
          case -1:
            await this.toggleLoadingRequesting(false)
            await this.toggleErrorRequesting(true)
            return false
          case -2:
            this.setState({
              message: this.props.t('signatureRequestAction2.dateError'),
            })
            await this.toggleLoadingRequesting(false)
            await this.toggleErrorRequesting(true)
            return false
          case -3:
            this.setState({
              message: this.props.t('signatureRequestAction2.termsConditionsError'),
            })
            await this.toggleLoadingRequesting(false)
            await this.toggleErrorRequesting(true)
            return false
          case -5:
            this.setState({
              message: this.props.t('signatureRequestAction2.signatureError'),
            })
            await this.toggleLoadingRequesting(false)
            await this.toggleErrorRequesting(true)
            return false
          case -6:
            this.setState({
              message: this.props.t('signatureRequestAction2.flowError'),
            })
            await this.toggleLoadingRequesting(false)
            await this.toggleErrorRequesting(true)
            return false
          case -7:
            this.setState({
              message: this.props.t('signatureRequest.pure.errorDomain') + '' + this.props.t('signatureRequest.pure.errorDomainS') + '' + this.props.t('signatureRequest.pure.errorDomainAll'),
              // messageSecond: this.props.t('signatureRequest.pure.errorDomainS'),
              // restOfTheMessage: this.props.t('signatureRequest.pure.errorDomainAll'),
            })
            await this.toggleLoadingRequesting(false)
            await this.toggleWarningRequesting(4000, this.props.t('signatureRequest.pure.errorDomain') + '' + this.props.t('signatureRequest.pure.errorDomainS') + '' + this.props.t('signatureRequest.pure.errorDomainAll'), this.props.t('signatureRequestProfileAction.dialog.title.validation.domain'))
            return false
          case 403:
            this.setState({
              message: this.props.t('signatureRequestAction2.adminMessageError'),
            })
            await this.toggleLoadingRequesting(false)
            await this.toggleErrorRequesting(true)
            return false
          case 420:
            this.setState({
              message: this.props.t('signatureRequestAction2.dataMessageError'),
            })
            await this.toggleLoadingRequesting(false)
            await this.toggleErrorRequesting(true)
            return false
          default:
            await this.toggleLoadingRequesting(false)
            await this.toggleErrorRequesting(true)
            return false
        }
      }
    } catch (error) {
      await this.toggleLoadingRequesting(false)
      await this.toggleErrorRequesting(true)
      return false
    }
  }

  setSigners = (valSigners) => {
    this.setState({ signers: valSigners })
  }

  setValidators = (valValidators) => this.setState({ validators: valValidators })


  changeSignerInEdit = (nameSigner, lastNameSigner) => {
    let signerInEdit = { ...this.state.signerInEdit }
    signerInEdit.nameSigner = nameSigner
    signerInEdit.lastNameSigner = lastNameSigner
    this.setState({ signerInEdit })
  }

  /**
   * @author  Lucia Alvarado
   * @description Get email of input
   * @updatedDate 24-08-2023
   * @memberof SignatureRequestProfileAction
  */
  changeSignerEmailInEdit = (event) => {
    let signerInEdit = { ...this.state.signerInEdit }
    signerInEdit.email = event.target.value
    this.setState({ signerInEdit })
  }

  //Request package
  setProfilesDocumentInPackage = (profiles) => {
    this.setState({
      profilesDocuments: profiles
    })
  }

  onSubmitSign = async (dataItem) => {
    this.setState({ message: null })
    let {
      nameSignature,
      date,
      comments,
      documentAccept,
      eventId,
      servicesId,
      signatureTypeId,
      processTypeId,
      // signers,
      // requireSignSupport,
      // selectedFile,
      timezone,
      profilesDocuments,
      exportPdf,
      signtureRequestProfile
    } = this.state
    if (this.state.errorCurrentNameSignature === true) {
      return false
    }
    if (this.state.errorCurrentDescription === true) {
      return false
    }
    if (this.state.errorCurrentComments === true) {
      return false
    }
    if (this.state.selectedFile === null) {
      this.setState({ errorFile: true })
      return false
    } else {
      this.setState({ errorFile: false })
    }
    let result = this.state.selectedFile.name.slice(-4)
    if (result.toLowerCase() !== '.pdf') {
      this.setState({ errorFile: true })
      return false
    } else {
      this.setState({ errorFile: false })
    }
    let signatureType = this.state.signatureTypesInputValue.find((item) => item.isActive) ?? {}
    let signatureTypeIdExist = signatureTypeId || signatureType?.id
    if (!signatureTypeIdExist) {
      await this.toggleErrorRequesting(true)

      // this.setState({ errorSignatureTypeId: true })
      return false
    }
    let processType = this.state.processTypesInputValue.find((item) => item.isActive) ?? {}
    let processTypeIdNew = this.state.processTypeId || processType?.id
    if (!processTypeIdNew) {
      this.setState({ errorProcessTypeId: true })
      return false
    }
    if (this.state.documentAccept === false) {
      this.setState({ errorAcceptDocument: true })
      return false
    } else {
      this.setState({ errorAcceptDocument: false })
    }
    if (this.state.signers.length <= 0) {
      this.setState({ errorNotSigners: false })
      return false
    } else {
      this.setState({
        errorNotSigners: false,
      })
    }
    if (
      this.state.validators.length <= 0 &&
      (this.state.processTypeId ===
        Number(process.env.REACT_APP_SIGNERS_PROCESS_TYPE_APPROVAL) ||
        this.state.processTypeId ===
        Number(
          process.env.REACT_APP_SIGNERS_PROCESS_TYPE_SEQUENTIAL_APPROVAL
        ))
    ) {
      this.setState({
        message: this.props.t('signatureRequestAction2.notAuthorizers')
      })
      this.toggleErrorRequesting(true)
      return false
    } else {
      this.setState({ errorNotValidators: false })
    }
    if (this.state.notification === true) this.onCloseOpenModal()
    try {
      await this.toggleLoadingRequesting(true)
      // Eliminar el nombre y apellido completo del valor nameSigner
      this.state.signers.map(signer => {
        if (this.state.signatureTypeId === process.env.REACT_APP_SIGNATURE_TYPE_AUTOGRAFA) {
          let newCoordinates = signer.coordinates.data.sort(function (a, b) {
            return a.page - b.page || b.y - a.y
          })
          signer.coordinates.data = newCoordinates
        }
      })

      if (
        String(this.state.processTypeId) ===
        String(process.env.REACT_APP_SIGNERS_PROCESS_TYPE_SEQUENTIAL)
      ) {
        dataItem.signers = this.state.signers.map((signer, index) => {
          return ({
            // ...signer,
            email: signer.email,
            numSign: signer.numSign,
            coordinates: signer.coordinates,

            firstLastName: signer.lastNameSigner,
            firstName: signer.nameSigner,
            signerTypeId:
              signer.type ?? Number(process.env.REACT_APP_SIGNERS_TYPE_INVITADO),
            order: index + 1,
            signerEvent: {
              signerEventTypeId: Number(
                process.env.REACT_APP_SIGNER_EVENT_TYPE_SOLICITUD
              ),
              eventId: 1,
            },
            phoneNumber: signer.phoneNumber,
            isSignerNoPassword: signer.isSignerNoPassword,
            sendDocument: signer.sendDocument,
            eventId: 1,
            proofOfLife: signer.proofOfLife,
            languageId: signer.languageId || 1
          })
        })
        eventId = 1
      }
      if (
        String(this.state.processTypeId) ===
        String(process.env.REACT_APP_SIGNERS_PROCESS_TYPE_APPROVAL)
      ) {
        let tempSigners = this.state.signers.map((signer) => {
          return ({
            // ...signer,
            email: signer.email,
            numSign: signer.numSign,
            firstLastName: signer.lastNameSigner,
            firstName: signer.nameSigner,
            coordinates: signer.coordinates,
            signerTypeId:
              signer.type ?? Number(process.env.REACT_APP_SIGNERS_TYPE_INVITADO),
            signerEvent: {
              signerEventTypeId: Number(
                process.env.REACT_APP_SIGNER_EVENT_TYPE_SOLICITUD
              ),
              eventId: 1,
            },
            phoneNumber: signer.phoneNumber,
            isSignerNoPassword: signer.isSignerNoPassword,
            sendDocument: signer.sendDocument,
            eventId: 1,
            proofOfLife: signer.proofOfLife,
            languageId: signer.languageId || 1
          })
        })
        let tempValidators = this.state.validators.map((signer) => ({
          // ...signer,
          email: signer.email,
          firstLastName: signer.lastNameSigner,
          firstName: signer.nameSigner,
          signerTypeId: signer.type,
          signerEvent: {
            signerEventTypeId: Number(
              process.env.REACT_APP_SIGNER_EVENT_TYPE_SOLICITUD
            ),
            eventId: 1,
          },
          eventId: 1,
          languageId: signer.languageId || 1
        }))
        dataItem.signers = tempSigners.concat(tempValidators)
        eventId = 1
      }
      if (
        String(this.state.processTypeId) ===
        String(process.env.REACT_APP_SIGNERS_PROCESS_TYPE_SEQUENTIAL_APPROVAL)
      ) {
        let tempSigners = this.state.signers.map((signer, index) => {
          return ({
            // ...signer,
            email: signer.email,
            numSign: signer.numSign,
            coordinates: signer.coordinates,
            firstLastName: signer.lastNameSigner,
            firstName: signer.nameSigner,
            signerTypeId:
              signer.type ?? Number(process.env.REACT_APP_SIGNERS_TYPE_INVITADO),
            order: index + 1,
            signerEvent: {
              signerEventTypeId: Number(
                process.env.REACT_APP_SIGNER_EVENT_TYPE_SOLICITUD
              ),
              eventId: 1,
            },
            phoneNumber: signer.phoneNumber,
            isSignerNoPassword: signer.isSignerNoPassword,
            sendDocument: signer.sendDocument,
            eventId: 1,
            proofOfLife: signer.proofOfLife,
            languageId: signer.languageId || 1
          })
        })
        let tempValidators = this.state.validators.map((signer, index) => ({
          // ...signer,
          email: signer.email,
          firstLastName: signer.lastNameSigner,
          firstName: signer.nameSigner,
          signerTypeId: signer.type,
          order: index + 1,
          signerEvent: {
            signerEventTypeId: Number(
              process.env.REACT_APP_SIGNER_EVENT_TYPE_SOLICITUD
            ),
            eventId: 1,
          },
          eventId: 1,
          languageId: signer.languageId || 1
        }))
        dataItem.signers = tempSigners.concat(tempValidators)
        eventId = 1
      }

      let signRequestBody = new FormData()
      let configFiles = []
      // profilesDocuments.map(profile => {
      //   let config = {
      //     name: profile.document.name,
      //     documentProfileGroupId: profile.id
      //   }

      //   if (profile.document && profile.document.file && profile.document.file.name) {
      //     configFiles.push(config)
      //     signRequestBody.append('files', profile.document.file)
      //   }
      //   return config
      // })

      // Determine if the selected subcategory is logical
      const logicalSubcategory = this.state.subCategories.find(sub => { return sub.id === this.state.subCategoryIdSelected && sub.logical })

      const hasSubcategory = Number(this.state.subCategoryIdSelected) > 0
      const dataClassifier = {
        companyId: this.state.companyIdSelected,
        categoryId: hasSubcategory && !logicalSubcategory ? this.state.categoryIdSelected : 0,
        subCategoryId: hasSubcategory && !logicalSubcategory ? this.state.subCategoryIdSelected : 0,
        typeDocument: this.state.typeDocumentSelected,
        pathBreadcrumb: hasSubcategory && !logicalSubcategory ? this.state.pathBreadcrumbSelected : ''
      }

      let documentManageId = (this.state.signatureProfileSelected && this.state.signatureProfileSelected.documentProfile && this.state.signatureProfileSelected.documentProfile.documentProfile && this.state.signatureProfileSelected.documentProfile.documentProfile.length > 0) ? +process.env.REACT_APP_DOCUMENT_MANAGE_ID_PACKAGE : +process.env.REACT_APP_DOCUMENT_MANAGE_ID_SIMPLE

      if (documentManageId === +process.env.REACT_APP_DOCUMENT_MANAGE_ID_PACKAGE) {
        profilesDocuments.map(profile => {
          const normalizedName = FormatTextUtil.normalizeFilename(profile.document.name)
          let config = {
            name: normalizedName,
            documentProfileGroupId: profile.id
          }

          if (profile.document && profile.document.file && profile.document.file.name) {
            configFiles.push(config)
            const normalizedFile = new File([profile.document.file], normalizedName, { type: profile.document.file.type })
            signRequestBody.append('files', normalizedFile)
          }
          return config
        })
      } else {
        const normalizedName = FormatTextUtil.normalizeFilename(this.state.selectedFile.name)
        let config = {
          name: normalizedName
        }
        configFiles.push(config)
        const normalizedFile = new File([this.state.selectedFile], normalizedName, { type: this.state.selectedFile.type })
        signRequestBody.append('files', normalizedFile)
      }

      // CRITICAL FIX: Do NOT copy signers from dataItem (grid data), only update order
      // The grid has concatenated names for display, but this.state.signers has correct separated fields
      if (
        (String(this.state.processTypeId) ===
          String(process.env.REACT_APP_SIGNERS_PROCESS_TYPE_SEQUENTIAL))) {
        /** @type {Array} */
        const gridSigners = JSON.parse(JSON.stringify(dataItem.signers))
        for (const mainSigner of gridSigners) {
          const signerFound = this.state.signers.find(signer => signer.email === mainSigner.email)
          if (signerFound) signerFound.id_order = mainSigner.order
        }
        // DO NOT: this.setState({ signers: gridSigners }) - this would overwrite correct data with concatenated names
      }

      if (
        (String(this.state.processTypeId) ===
          String(process.env.REACT_APP_SIGNERS_PROCESS_TYPE_SEQUENTIAL_APPROVAL))) {
        /** @type {Array} */
        const gridSigners = JSON.parse(JSON.stringify(dataItem.signers))
        const gridSignersFiltered = gridSigners.filter(signer => signer.signerTypeId !== +process.env.REACT_APP_SIGNERS_TYPE_VALIDATOR)

        for (const mainSigner of gridSignersFiltered) {
          const signerFound = this.state.signers.find(signer => signer.email === mainSigner.email)
          if (signerFound) signerFound.id_order = mainSigner.order
        }

        /** @type {Array} */
        const gridValidators = gridSigners.filter(validator => validator.signerTypeId === +process.env.REACT_APP_SIGNERS_TYPE_VALIDATOR)
        for (const mainValidator of gridValidators) {
          const validatorFound = this.state.validators.find(validator => validator.email === mainValidator.email)
          if (validatorFound) validatorFound.id_order = mainValidator.order
        }
      }


      const buildSigners = (user, isSigner = false, index) => {
        let {
          email,
          type,
          sendDocument,
          id_order: order,
          proofOfLife,
          coordinates,
          phoneNumber,
          isSignerNoPassword,
          noPasswordRequired
        } = user

        let firstName = user.firstName ?? user.nameSigner ?? ''
        let firstLastName = user.firstLastName ?? null
        let secondLastName = user.secondLastName ?? null

        // Only split lastNameSigner if BOTH firstLastName AND secondLastName are missing
        // This prevents overwriting correctly separated names
        if (!firstLastName && !secondLastName) {
          // Try firstLastNameSigner/secondLastNameSigner first
          firstLastName = user.firstLastNameSigner ?? null
          secondLastName = user.secondLastNameSigner ?? null

          // If still missing, try to split lastNameSigner as last resort
          if (!firstLastName && !secondLastName) {
            const ln = (user.lastNameSigner || '').toString().trim()
            if (ln) {
              const parts = ln.split(/\s+/)
              firstLastName = parts[0] || ''
              secondLastName = parts.slice(1).join(' ') || ''
            }
          }
        }
        let signerTypeId = type ?? Number(process.env.REACT_APP_SIGNERS_TYPE_INVITADO)

        let [countryCode, phoneSigner] = [null, null]

        if (phoneNumber) {
          let splittedPhone = formatPhoneNumberIntl(phoneNumber).split(' ')
          countryCode = splittedPhone.splice(0, 1)[0]
          phoneSigner = splittedPhone.join('')
        }

        return {
          email,
          firstLastName: firstLastName,
          firstName: firstName,
          secondLastName,
          signerTypeId,
          sendDocument,
          eventId: 1,
          order: order || index + 1,
          proofOfLife: isSigner ? proofOfLife : undefined,
          phoneSigner,
          countryCode,
          isSignerNoPassword: noPasswordRequired ?? isSignerNoPassword ?? false,
          languageId: user.languageId || 1,
          signerEvent: isSigner
            ? {
              signerEventTypeId: 1,
              eventId: 1,
            }
            : undefined,
          coordinates: isSigner ? coordinates || null : undefined,
        }
      }

      let signers = [
        ...this.state.signers.map((signer, index) => buildSigners(signer, true, index)),
        ...this.state.validators.map((validator, index) => buildSigners(validator, false, index)),
      ]
      var d = new Date().getTime()
      const reference = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0
        d = Math.floor(d / 16)
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
      })

      let signData = [{
        name: nameSignature,
        reference,
        comments,
        signtureRequestProfile,
        configFiles,
        signers
      }]

      let awsUrl = this.state.contractFromNegotiation && this.state.contractFromNegotiation.url ? this.state.contractFromNegotiation.url : ''
      if (!awsUrl && this.state.documentFromVault && this.state.documentFromVault.url) awsUrl = this.state.documentFromVault.url

      //       signRequestBody.append('name', nameSignature)
      //       signRequestBody.append('description', description)
      //       signRequestBody.append('comments', comments)
      //       signRequestBody.append('eventId', eventId)
      //       signRequestBody.append('limitDate', date)
      //       signRequestBody.append('documentAccept', documentAccept)
      //       signRequestBody.append('signatureTypeId', signatureTypeId)
      //       signRequestBody.append('servicesId', JSON.stringify(servicesId))
      //       signRequestBody.append('processTypeId', processTypeId)
      //       signRequestBody.append('requireSignSupport', requireSignSupport)
      //       signRequestBody.append('timezone', timezone)
      //       signRequestBody.append('signers', JSON.stringify(dataItem.signers))
      //       signRequestBody.append('documentManageId', 5)
      //       signRequestBody.append('configFiles', JSON.stringify(configFiles))
      //       signRequestBody.append('dataClassifier', JSON.stringify(dataClassifier))
      signRequestBody.append('limitDate', date)
      signRequestBody.append('documentAccept', documentAccept)
      signRequestBody.append('exportPdf', exportPdf)
      signRequestBody.append('servicesId', JSON.stringify(servicesId))
      signRequestBody.append('signatureTypeId', signatureTypeId)
      signRequestBody.append('processTypeId', processTypeId)
      signRequestBody.append('timezone', timezone)
      signRequestBody.append('dataClassifier', JSON.stringify(dataClassifier))
      signRequestBody.append('signData', JSON.stringify(signData))
      signRequestBody.append('documentManageId', documentManageId)
      signRequestBody.append('awsUrl', awsUrl)
      if (this.state.proofOfLifeChecked) signRequestBody.append('proofOfLifeOnlyPhoto', this.state.proofOfLifeOnlyPhoto)

      let signRequestPackage = await this.signatureRequestService.createSignRequest(signRequestBody, this.token)
      if (signRequestPackage && Number(signRequestPackage.statusCode) === 200) {
        await this.toggleLoadingRequesting(false)
        await this.toggleCompletedRequesting(true)
        return true
      } else if (Number(signRequestPackage.statusCode) === 409) {
        await this.toggleLoadingRequesting(false)
        this.setState({
          message: `${this.props.t('signatureRequestProfile.errors.signers.inactive')}`
        })
        await this.toggleErrorRequesting(true)
        return false
      } else if (Number(signRequestPackage.statusCode) === -100) {
        let docsName = ''
        if (signRequestPackage.data) {
          let nameComas = signRequestPackage.data.toString()
          nameComas = nameComas.replaceAll(',', ' ')
          docsName = `${nameComas}.`
        }
        await this.toggleLoadingRequesting(false)
        this.setState({
          message: `${this.props.t('signatureRequestProfile.errors.documents.fewer.pages')}${docsName}`
        })
        await this.toggleErrorRequesting(true)
        return false
      } else {
        this.setState({ message: this.props.t('signatureRequestProfile.errors.general.create.sign') })
        await this.toggleLoadingRequesting(false)
        await this.toggleErrorRequesting(true)
        return false
      }
    } catch {
      this.setState({ message: this.props.t('signatureRequestProfile.errors.general.create.sign') })
      await this.toggleLoadingRequesting(false)
      await this.toggleErrorRequesting(true)
      return false
    }
  }

  getPreferences = async () => {
    try {
      let preferences = await this.clientService.getClientPreferences(this.token, this.timezone)
      if (preferences && preferences.data && Number(preferences.statusCode) === 200) {
        let preferenceProcedureUser = preferences.data.find((preference) => preference.preferenceName === process.env.REACT_APP_PREFERENCE_ADD_SIGNERS_NO_PASSWORD)
        let preferenceValue = (preferenceProcedureUser) ? preferenceProcedureUser.booleanValue : false
        if (preferenceValue) {
          this.setState({
            signersNoPassword: true
          })
        }
      } else {
        this.setState({ message: this.props.t('signatureRequestProfileAction.error.preferences') })
        await this.toggleLoadingRequesting(false)
        await this.toggleErrorRequesting(true)
        return false
      }
    } catch (error) {
      this.setState({ message: this.props.t('signatureRequestProfileAction.error.preferences') })
      await this.toggleLoadingRequesting(false)
      await this.toggleErrorRequesting(true)
      return false
    }
  }

  getTypeDocuments = async () => {
    try {
      let typeDocumentsBD = await this.categoryService.getTypeDocuments(this.token, 'Documento')
      if (typeDocumentsBD && typeDocumentsBD.data && Number(typeDocumentsBD.statusCode) === 200) {
        let typeDocuments = typeDocumentsBD.data
        typeDocuments.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
        this.setState({
          typeDocuments
        })
      } else {
        this.setState({ message: this.props.t('signatureRequestProfileAction.error.typedocuments') })
        await this.toggleLoadingRequesting(false)
        await this.toggleErrorRequesting(true)
        return false
      }
    } catch (error) {
      this.setState({ message: this.props.t('signatureRequestProfileAction.error.typedocuments') })
      await this.toggleLoadingRequesting(false)
      await this.toggleErrorRequesting(true)
      return false
    }
  }

  getCompanies = async () => {
    this.toggleLoadingRequesting(true)
    try {
      let companiesBD = await this.companyService.getUsersCompanies(this.token, this.ENV.REACT_APP_ENDPOINT_COMPANIES_ORIGIN_SIGN_REQUEST)
      if (companiesBD && companiesBD.data && Number(companiesBD.statusCode) === 200) {
        let companies = companiesBD.data.map(company => ({
          id: company.company.id,
          companyName: company.company.companyName,
        }))
        companies = companies.sort((a, b) => a.companyName.toLowerCase().localeCompare(b.companyName.toLowerCase()))
        let noAssign = {
          companyName: this.props.t('signatureRequestProfile.digitalVault.withoutAssign'),
          id: NIL_UUID
        }
        companies.unshift(noAssign)
        this.setState({
          userCompanies: companies,
          categories: [{ id: 0, name: this.props.t('signatureRequestProfile.digitalVault.withoutAssign') }],
          subCategories: [{ items: [], subcategory: {} }]
        })

        this.toggleLoadingRequesting(false)
      } else {
        this.setState({ message: this.props.t('signatureRequestProfileAction.error.companies') })
        await this.toggleLoadingRequesting(false)
        await this.toggleErrorRequesting(true)
        return false
      }
    } catch (error) {
      this.setState({ message: this.props.t('signatureRequestProfileAction.error.companies') })
      await this.toggleLoadingRequesting(false)
      await this.toggleErrorRequesting(true)
      return false
    }
  }

  getCategories = async (companyId, setCategoryId, setSelect) => {
    if (companyId === NIL_UUID) {
      this.setState({ categories: [], subCategories: [] })
      setCategoryId(0)
      setSelect([''])
      return
    }

    this.toggleLoadingRequesting(true);
    try {

      let categoriesBD = await this.categoryService.getAllCategoriesByCompanyId({
        companyId: companyId,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        token: this.token,
        origin: this.ENV.REACT_APP_ENDPOINT_COMPANIES_ORIGIN_SIGN_REQUEST
      });

      if (categoriesBD && categoriesBD.data && Number(categoriesBD.statusCode) === 200) {
        let categories = categoriesBD.data.fileData || []
        let permission = categoriesBD.data.permission || {}

        this.setState({
          categories: categories || [],
          subCategories: categories || [],
          permission: permission
        })

        setCategoryId(0)
        setSelect([''])
        this.toggleLoadingRequesting(false)
      } else {
        this.setState({ message: this.props.t('signatureRequestProfileAction.error.categories') })
        await this.toggleLoadingRequesting(false)
        await this.toggleErrorRequesting(true)
        return false
      }
    } catch (error) {
      this.setState({ message: this.props.t('signatureRequestProfileAction.error.categories') })
      await this.toggleLoadingRequesting(false)
      await this.toggleErrorRequesting(true)
      return false
    }
  }


  setDigitalVaultCategory = async (setCompanyId, setTypeDocument, setCategoryId, setSelect, setExpand) => {
    let isMounted = true;

    this.toggleLoadingRequesting(true);

    let categories = [];
    let subCategories = [];
    let pathBreadcrumbSelected = this.state.pathBreadcrumbSelected || "";
    let index = "";

    const isPackageSignature = this.state.signatureProfileSelected &&
      this.state.signatureProfileSelected.documentProfile &&
      this.state.signatureProfileSelected.documentProfile.documentProfile &&
      this.state.signatureProfileSelected.documentProfile.documentProfile.length > 0;

    const shouldLoadStoredData = !isPackageSignature || !this.state.isFirstTimeCategories;

    try {

      let companiesBD = await this.companyService.getUsersCompanies(this.token, this.ENV.REACT_APP_ENDPOINT_COMPANIES_ORIGIN_SIGN_REQUEST)
      if (!companiesBD || !companiesBD.data || Number(companiesBD.statusCode) !== 200)
        throw new Error(this.props.t("signatureRequestProfileAction.error.companies"));

      let companies = companiesBD.data
        .map((company) => ({
          id: company.company.id,
          companyName: company.company.companyName,
        }))
        .sort((a, b) =>
          a.companyName.toLowerCase().localeCompare(b.companyName.toLowerCase())
        );

      let noAssign = {
        companyName: this.props.t("signatureRequestProfile.digitalVault.withoutAssign"),
        id: NIL_UUID,
      };
      companies.unshift(noAssign);

      let typeDocumentsBD = await this.categoryService.getTypeDocuments(
        this.token,
        "Documento"
      );
      if (
        !typeDocumentsBD ||
        !typeDocumentsBD.data ||
        Number(typeDocumentsBD.statusCode) !== 200
      )
        throw new Error(
          this.props.t("signatureRequestProfileAction.error.typedocuments")
        );

      let typeDocuments = typeDocumentsBD.data.sort((a, b) =>
        a.name.toLowerCase().localeCompare(b.name.toLowerCase())
      );
      const selectedTypeDocId = (this.state.typeDocumentSelected && typeof this.state.typeDocumentSelected === 'object')
        ? this.state.typeDocumentSelected.id
        : this.state.typeDocumentSelected
      let typeDocumentSelected = typeDocuments.find((doc) => doc.id === selectedTypeDocId)

      if (
        shouldLoadStoredData &&
        this.state.companyIdSelected &&
        this.state.companyIdSelected !== NIL_UUID &&
        this.state.categoryIdSelected
      ) {
        let categoriesBD = await this.categoryService.getCategories(
          this.token,
          this.state.companyIdSelected
        );
        if (
          !categoriesBD ||
          !categoriesBD.data ||
          Number(categoriesBD.statusCode) !== 200
        )
          throw new Error(
            this.props.t("signatureRequestProfileAction.error.categories")
          );

        categories = categoriesBD.data.sort((a, b) =>
          a.name.toLowerCase().localeCompare(b.name.toLowerCase())
        );
      }

      if (
        shouldLoadStoredData &&
        this.state.companyIdSelected &&
        this.state.companyIdSelected !== NIL_UUID
      ) {
        const allCats = await this.categoryService.getAllCategoriesByCompanyId({
          companyId: this.state.companyIdSelected,
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          token: this.token,
          origin: this.ENV.REACT_APP_ENDPOINT_COMPANIES_ORIGIN_SIGN_REQUEST
        });

        if (
          allCats &&
          allCats.data &&
          Number(allCats.statusCode) === 200 &&
          Array.isArray(allCats.data.fileData)
        ) {
          subCategories = allCats.data.fileData.sort((a, b) =>
            a.name.toLowerCase().localeCompare(b.name.toLowerCase())
          );
        }
      }

      let categoryNameSelected = "";
      let subCategoryNameSelected = "";

      if (shouldLoadStoredData && pathBreadcrumbSelected) {
        const ids = pathBreadcrumbSelected.split("/").map(Number);

        const findNodeById = (nodes, id) => {
          return nodes.find(n => Number(n.id) === Number(id)) || null;
        };

        let categoryNameSelected = "";
        let subCategoryNameSelected = "";

        if (pathBreadcrumbSelected) {
          const ids = pathBreadcrumbSelected.split("/").map(Number);

          if (ids[0]) {
            const category = findNodeById(subCategories, ids[0]);
            if (category) categoryNameSelected = category.name;
          }

          if (ids.length > 1) {
            const sub = findNodeById(subCategories, ids[ids.length - 1]);
            if (sub) subCategoryNameSelected = sub.name;
          }
        }
      }

      this.setState({
        ...this.state,
        categoryNameSelected,
        subCategoryNameSelected,
      });

      if (shouldLoadStoredData && subCategories && subCategories.length > 0 && pathBreadcrumbSelected) {
        const ids = pathBreadcrumbSelected.split("/").map(Number);

        const findInTree = (nodes, targetId) => {
          for (const node of nodes) {
            if (node.subcategory?.id === targetId) return node;
            if (node.items && node.items.length > 0) {
              const found = findInTree(node.items, targetId);
              if (found) return found;
            }
          }
          return null;
        };

        let categoryNameSelected = "";
        let subCategoryNameSelected = "";

        if (ids[0]) {
          const category = findInTree(subCategories, ids[0]);
          if (category) categoryNameSelected = category.subcategory.name;
        }

        if (ids.length > 1) {
          const sub = findInTree(subCategories, ids[ids.length - 1]);
          if (sub) subCategoryNameSelected = sub.subcategory.name;
        }

        this.setState({ categoryNameSelected, subCategoryNameSelected });
      }

      if (shouldLoadStoredData && pathBreadcrumbSelected) {
        const idsExpand = pathBreadcrumbSelected.split("/").map(Number);
        setExpand({
          ids: idsExpand,
          idField: "subcategory.id",
        });
      }

      const companyId = shouldLoadStoredData ? this.state.companyIdSelected : NIL_UUID
      const typeDocument = shouldLoadStoredData ? (typeDocumentSelected || {}) : {}
      const categoryId = shouldLoadStoredData ? this.state.categoryIdSelected : 0
      const subcategoryId = shouldLoadStoredData ? this.state.subCategoryIdSelected : 0

      setCompanyId(companyId);
      setTypeDocument(typeDocument);
      setCategoryId(categoryId);
      const selectedNodeId = (subcategoryId && Number(subcategoryId) > 0) ? subcategoryId : categoryId
      if (shouldLoadStoredData && selectedNodeId) setSelect([`${selectedNodeId}`])
      if (!isMounted) return

      // En setDigitalVaultCategory, después de calcular los nombres:
      this.setState({
        companyIdSelected: companyId,
        typeDocumentSelected: typeDocument,
        categoryIdSelected: categoryId,
        subCategoryIdSelected: subcategoryId,
        companies,
        categories,
        subCategories,
        typeDocuments,
        pathBreadcrumbSelected: shouldLoadStoredData ? pathBreadcrumbSelected : '',
        allTypeDocuments: typeDocumentsBD.data,
        categoryNameSelected,
        subCategoryNameSelected
      });

      this.setTypeDocuments(typeDocumentSelected, setTypeDocument)
      this.toggleLoadingRequesting(false)
    } catch (error) {
      this.toggleLoadingRequesting(false)
      return false
    }
  }


  setCheckedProofOfLife = (e) => {
    let checkBoxId = (e && e.target && e.target.element && e.target.element && e.target.element.id) ? e.target.element.id : ''
    if (checkBoxId && this.state.proofLifeCheckboxId) {
      if (checkBoxId === this.state.proofLifeCheckboxId) {
        this.setState({
          proofOfLifeChecked: false,
          proofLifeCheckboxId: ''
        })
      } else {
        let proofOfLifeChecked = (checkBoxId === 'proofOfLife') ? true : false
        this.setState({
          proofOfLifeChecked,
          proofLifeCheckboxId: checkBoxId,
        })
      }
    } else {
      let proofOfLifeChecked = (checkBoxId === 'proofOfLife') ? true : false
      this.setState({
        proofOfLifeChecked,
        proofLifeCheckboxId: checkBoxId,
      })
    }

    if (!this.state.proofLifeCheckboxId && checkBoxId) {
      let newSigners = this.state.signers.map((signer) => {
        const hasNoPassword = signer.noPasswordRequired || signer.isSignerNoPassword || false
        const isInvited = signer.type === Number(process.env.REACT_APP_SIGNERS_TYPE_INVITADO) || !signer.type
        signer.proofOfLife = (checkBoxId === 'proofOfLife' && isInvited && !hasNoPassword) ? true : false
        return signer
      })

      this.setState({
        signers: newSigners
      })
    }

    if (!e.value) {
      let newSigners = this.state.signers.map((signer) => {
        signer.proofOfLife = false
        return signer
      })

      this.setState({
        signers: newSigners
      })
    }
  }

  getCollabsOrInvites = async (typeUser, offset, limit, email) => {
    this.toggleLoadingRequesting(true)
    let collaboratorListAllow = []
    let inviteListAllow = []

    try {
      let collaborators = (typeUser === 1) ? true : false
      let invites = (typeUser === 2 || typeUser === 3) ? true : false
      if (typeUser === 3) {
        offset = 0
        limit = 50
      }

      let usersCollabotartorInvites = await this.UserService.getUsersCollaboratorsOrInvites(this.token, collaborators, invites, offset, limit, email)
      if (usersCollabotartorInvites) {
        if (usersCollabotartorInvites.usersCollaborator && usersCollabotartorInvites.usersCollaborator.active && usersCollabotartorInvites.usersCollaborator.active.length > 0) collaboratorListAllow = usersCollabotartorInvites.usersCollaborator.active
        if (usersCollabotartorInvites.usersInvite && usersCollabotartorInvites.usersInvite.active && usersCollabotartorInvites.usersInvite.active.length > 0) inviteListAllow = usersCollabotartorInvites.usersInvite.active

        const allUsersCollaborator = usersCollabotartorInvites.usersCollaborator.active && usersCollabotartorInvites.usersCollaborator.inactive ? usersCollabotartorInvites.usersCollaborator.active.concat(usersCollabotartorInvites.usersCollaborator.inactive) : []
        const allUsersInvite = usersCollabotartorInvites.usersInvite.active && usersCollabotartorInvites.usersInvite.inactive ? usersCollabotartorInvites.usersInvite.active.concat(usersCollabotartorInvites.usersInvite.inactive) : []

        this.setState({
          collaboratorListAllow,
          inviteListAllow,
          allUsersCollaborator,
          allUsersInvite
        })
      }
      this.toggleLoadingRequesting(false)
      this.toggleShowDialogList(true)
      return { invites: inviteListAllow, collaborators: collaboratorListAllow }
    } catch (error) {
      this.toggleLoadingRequesting(false)
      return { invites: inviteListAllow, collaborators: collaboratorListAllow }
    }
  }

  toggleWarningRequesting = (time, message, titleDialog, close) => {
    this.setState({
      isWarnign: true,
      messageWarning: message,
      titleDialog
    })

    if (close) {
      setTimeout(() => {
        this.setState({
          isWarnign: false,
          messageWarning: '',
          titleDialog: ''
        })
      }, time || 4000)
    }
  }

  toggleCloseWarningRequesting = () => {
    this.setState({
      isWarnign: false,
      messageWarning: '',
      titleDialog: ''
    })
  }

  setTypeDocuments = (typeDocument, setTypeDocument) => {
    if (this.state.allTypeDocuments.length === 0) return

    let infoTypeString = this.ENV.REACT_APP_DIGITAL_VAULT_DOCUMENT
    const proofOfLifeExist = this.state.proofOfLifeChecked || this.state.signers.some(signer => signer.proofOfLife)
    const pscExist = !!(this.state.serviceCMChecked || this.state.serviceSTChecked)
    const someDocuments = (this.state.profilesDocuments && this.state.profilesDocuments.length > 1) ? true : false
    if (someDocuments || proofOfLifeExist || pscExist) infoTypeString = this.ENV.REACT_APP_DIGITAL_VAULT_EXPEDIENTE

    let typeDocumentsFiltered = this.state.allTypeDocuments.filter(td => { return td.infoType === infoTypeString })
    if (typeDocument && typeDocument.infoType && typeDocument.infoType !== infoTypeString) setTypeDocument('')

    this.setState({
      typeDocuments: typeDocumentsFiltered
    })
  }

  // Función para crear subcategoría (IGUAL que questionnaires)
  createSubcategory = async ({ categoryName, companyId, parentId }) => {
    // NO mostrar modales aquí, el componente los maneja localmente
    try {
      const level = 2
      const response = await this.categoryService.createNewCategory(
        categoryName,
        null,
        null,
        null,
        'Custom',
        companyId,
        'Sub',
        level,
        parentId,
        false,
        this.token
      )

      if (response && response.data && response.statusCode === 200) {
        return response.data
      } else {
        return null
      }
    } catch (error) {
      console.error(error)
      return null
    }
  }

  // Función para refrescar categorías después de crear una subcategoría (IGUAL que questionnaires)
  refreshCategories = async (companyId) => {
    try {
      const response = await this.categoryService.getAllCategoriesByCompanyId({
        companyId,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        token: this.token,
        origin: this.ENV.REACT_APP_ENDPOINT_COMPANIES_ORIGIN_SIGN_REQUEST
      }, true) // refresh = true (IMPORTANTE)

      if (response && response.data && Number(response.statusCode) === 200) {
        const categories = response.data.fileData || []
        // Actualizar el state con las categorías nuevas
        this.setState({ subCategories: categories, categories: categories })
        return response
      }
    } catch (err) {
      console.error('Error refreshing categories:', err)
    }
  }

  render() {
    if (this.state.loadingContractsSignatures) {
      return (
        <div className='standard-wrapper'>
          <SimpleLoading />
        </div>
      )
    }
    if (
      this.state.contractsSignatures &&
      this.state.contractsSignatures.data === true
    ) {
      return (
        <SignatureRequestProfileView
          {...this.state}
          {...this.props}
          onChangeProofOfLifeOption={this.onChangeProofOfLifeOption}
          onChangePhoneNumber={this.onChangePhoneNumber}
          isExternalSignature={this.isExternalSignature}
          insertSignaturesBySigner={this.insertSignaturesBySigner}
          history={this.props.history}
          saveNewPdf={this.saveNewPdf}
          changeSignerInEdit={this.changeSignerInEdit}
          changeSignerEmailInEdit={this.changeSignerEmailInEdit}
          signers={this.state.signers.map((item, index, arr) => ({
            ...item,
            numSign: (this.state.signatureProfileSelected && this.state.signatureProfileSelected.documentProfile && this.state.signatureProfileSelected.documentProfile.documentProfile && this.state.signatureProfileSelected.documentProfile.documentProfile.length > 0 && this.state.signatureProfileSelected.documentProfile.totalSigns && this.state.signatureProfileSelected.documentProfile.totalSigns.length > 0) ? this.state.signatureProfileSelected.documentProfile.totalSigns.find(sign => sign.signerPosition === index + 1)?.totalSigns || 0 : item.numSign || 0,
            is: 'signer',
            type:
              item.type ?? Number(process.env.REACT_APP_SIGNERS_TYPE_INVITADO),
            typeName: item.typeName ?? 'Invitado',
            id_order: index + 1,
            isLastItem: arr.length - 1 === index,
          }))}
          validators={this.state.validators.map((item, index, arr) => ({
            ...item,
            is: 'validator',
            id_order: index + 1,
            isLastItem: arr.length - 1 === index,
          }))}
          steps={this.steps}
          stepMetadata={this.stepMetadata}

          DragCell={DragCell}
          setImgSignature={(params) => this.setState(params)}
          setSignatureImgeData={this.setSignatureImgeData}
          onImageChange={this.onImageChange}
          onUploadFile={this.onUploadFile}
          onDeleteFile={this.onDeleteFile}
          validator={this.validator}
          onToggleSignModal={this.onToggleSignModal}
          onHandleGeneralChange={this.onHandleGeneralChange}
          onHandleShowPassword={this.onHandleShowPassword}
          onHandleShowPasswordConfirm={this.onHandleShowPasswordConfirm}
          onHandleHideError={this.onHandleHideError}
          onChangeSummaryDescription={this.onChangeSummaryDescription}

          handleFile={this.handleFile}
          handleDeleteFile={this.handleDeleteFile}
          onDocumentLoadSuccess={this.onDocumentLoadSuccess}
          goToPrevPage={this.goToPrevPage}
          goToNextPage={this.goToNextPage}
          onZoomIn={this.onZoomIn}
          onZoomOut={this.onZoomOut}
          goToSelectPage={this.goToSelectPage}
          getCollaborator={this.getCollaborator}

          handleChangeCheckbox={this.handleChangeCheckbox}
          handleChangeCheckConfirm={this.handleChangeCheckConfirm}
          setServices={this.setServices}
          setSignatureTypes={this.setSignatureTypes}
          setProcessTypes={this.setProcessTypes}

          resetNotErrors={() =>
            this.setState({ errorNotValidators: false, errorNotSigners: false, errorNotSigns: false })
          }

          changeRows={this.changeRows}
          setSigners={this.setSigners}
          setValidators={this.setValidators}
          regex={this.regex}
          validateInput={ValidateInputPure}

          onSubmit={this.onSubmit}

          onCancelData={this.onCancelData}
          // handleChangeCheckbox={this.handleChangeCheckbox}

          save={this.save}
          edit={this.edit}
          remove={this.remove}
          cancel={this.cancel}
          insert={this.insert}
          insertCollaborator={this.insertCollaborator}
          insertValidator={this.insertValidator}
          dialogTitle={this.dialogTitle}
          insertNoPassword={this.insertNoPassword}

          cloneProduct={this.cloneProduct}
          newProduct={this.newProduct}
          handleName={this.handleName}
          handleDescription={this.handleDescription}
          UserService={this.UserService}

          handleSubmit={this.handleSubmit}
          handleSubmitConfirm={this.handleSubmitConfirm}
          handleSubmitList={this.handleSubmitList}
          selectSigner={this.selectSigner}
          onDialogInputChange={this.onDialogInputChange}

          notification={this.notification}
          onCloseOpenModal={this.onCloseOpenModal}

          toggleLoadingRequesting={this.toggleLoadingRequesting}
          toggleCompletedRequesting={this.toggleCompletedRequesting}
          toggleErrorRequesting={this.toggleErrorRequesting}
          toggleWarningRequesting={this.toggleWarningRequesting}
          toggleDialogDeleteSigner={this.toggleDialogDeleteSigner}
          toggleErrorDomain={this.toggleErrorDomain}
          toggleErrorDomainInvited={this.toggleErrorDomainInvited}
          toggleCloseWarningRequesting={this.toggleCloseWarningRequesting}

          token={this.token}
          onChangeNameSignature={this.onChangeNameSignature}
          onChangeComments={this.onChangeComments}
          onValidateProfileData={this.onValidateProfileData}

          scrollWindow={this.scrollWindow}
          setRequireSignSupport={() => this.setState({ requireSignSupport: !this.state.requireSignSupport })}

          onSelectServiceConservationMessage={this.onSelectServiceConservationMessage}
          onSelectServiceTime={this.onSelectServiceTime}
          onSelectESign={this.onSelectESign}
          onSelectAdvanced={this.onSelectAdvanced}
          onSelectAutograph={this.onSelectAutograph}
          onSelectRandom={this.onSelectRandom}
          onSelectAprovation={this.onSelectAprovation}
          onSelectAprovationSequential={this.onSelectAprovationSequential}
          onSelectSequential={this.onSelectSequential}

          onSigners={this.onSigners}
          handleChangeLimitDate={this.handleChangeLimitDate}
          onSelectServiceST={this.onSelectServiceST}
          onSelectServiceCM={this.onSelectServiceCM}
          toggleShowDialogList={this.toggleShowDialogList}
          saveArraSelectedList={this.saveArraSelectedList}
          userSelectedList={this.userSelectedList}

          setProfilesDocumentInPackage={this.setProfilesDocumentInPackage}
          onSubmitSign={this.onSubmitSign}

          pdfToBase64={this.pdfToBase64}

          getCompanies={this.getCompanies}
          getTypeDocuments={this.getTypeDocuments}
          getCategories={this.getCategories}
          getSubcategories={this.getSubcategories}
          setDigitalVaultCategory={this.setDigitalVaultCategory}
          createSubcategory={this.createSubcategory}
          refreshCategories={this.refreshCategories}

          setCheckedProofOfLife={this.setCheckedProofOfLife}

          getCollabsOrInvites={this.getCollabsOrInvites}
          setTypeDocuments={this.setTypeDocuments}

          categoryNameSelected={this.state.categoryNameSelected}
          subCategoryNameSelected={this.state.subCategoryNameSelected}

        />
      )
    }
    else {
      return (
        <Container
          xs={12}
          style={globalContainerStyles}
        >
          <VerifyContract />
          <Container
            xs={12}
            style={containerInformationContactPlanStyles}
          >
            <Grid
              container
              spacing={2}
              style={gridInformationContactPlanStyles}
            >
              <PromotionalFooterPure />
            </Grid>
          </Container>
        </Container>
      )
    }
  }
}

// function SignatureRequestProfileActionContainer(props) {
//   const { t } = useTranslation()
//   const { setShowError } = useContext(Context)
//   return (
//     <SignatureRequestProfileAction {...props} t={t} setShowError={setShowError} />
//   )
// }

export default withRouter(withTranslation()(SignatureRequestProfileAction))